{
  "common": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "add": "Ajouter",
    "create": "Créer",
    "update": "Mettre à jour",
    "loading": "Chargement...",
    "error": "Erreur",
    "success": "Succès",
    "gotIt": "Compris",
    "confirm": "Confirmer",
    "yes": "Oui",
    "no": "Non",
    "search": "Rechercher",
    "filter": "Filtrer",
    "name": "Nom",
    "description": "Description",
    "date": "Date",
    "amount": "Montant",
    "status": "Statut",
    "type": "Type",
    "email": "Courriel",
    "phone": "Téléphone",
    "language": "Langue",
    "unknown": "Inconnu",
    "back": "Retour",
    "continue": "Continuer",
    "backToDashboard": "Retour au tableau de bord",
    "backToSettings": "Retour aux paramètres",
    "copy": "Copier",
    "copied": "Copié!"
  },
  "navigation": {
    "dashboard": "Tableau de bord",
    "customers": "Contacts",
    "deals": "Dossiers",
    "tasks": "Tâches",
    "conversations": "Messages",
    "scenarios": "Scénarios",
    "settings": "Paramètres",
    "leads": "Prospects",
    "calendar": "Calendrier",
    "calculator": "Calculateur",
    "calls": "Appels",
    "users": "Utilisateurs",
    "reports": "Rapports",
    "liveChat": "Chat en direct"
  },
  "impersonation": {
    "warning": "⚠️ Vous impersonnifiez un utilisateur. Toutes les actions seront enregistrées.",
    "switchBack": "Retourner à l'admin"
  },
  "sidebar": {
    "editSidebar": "Modifier la barre latérale",
    "customizeNavigation": "Personnaliser la navigation",
    "availablePages": "Pages disponibles",
    "currentPages": "Pages actuelles",
    "dragToReorder": "Glisser pour réorganiser",
    "clickToRemove": "Cliquer pour retirer",
    "clickToAdd": "Cliquer pour ajouter",
    "resetToDefault": "Réinitialiser par défaut",
    "saveChanges": "Enregistrer les modifications",
    "discardChanges": "Annuler les modifications",
    "sidebarCustomized": "Barre latérale personnalisée avec succès",
    "sidebarReset": "Barre latérale réinitialisée par défaut"
  },
  "calendar": {
    "title": "Calendrier",
    "subtitle": "Gérez vos tâches, dossiers et rendez-vous",
    "event": "événement",
    "events": "événements",
    "views": {
      "month": "Mois",
      "week": "Semaine", 
      "day": "Jour",
      "list": "Liste",
      "year": "Année"
    },
    "navigation": {
      "previous": "Précédent",
      "today": "Aujourd'hui",
      "next": "Suivant",
      "loadingEvents": "Chargement des événements..."
    },
    "actions": {
      "createEvent": "Créer un événement"
    },
    "eventModal": {
      "title": "Détails de l'événement",
      "close": "Fermer",
      "fields": {
        "title": "Titre",
        "type": "Type",
        "startDate": "Date de début",
        "endDate": "Date de fin",
        "startTime": "Heure de début",
        "endTime": "Heure de fin",
        "allDay": "Toute la journée",
        "priority": "Priorité",
        "description": "Description",
        "customerName": "Nom du client",
        "customerEmail": "Courriel du client",
        "customerPhone": "Téléphone du client",
        "meetingType": "Type de réunion",
        "customerNotes": "Notes du client"
      },
      "types": {
        "custom": "Personnalisé",
        "task": "Tâche",
        "deal": "Dossier",
        "lead": "Prospect",
        "appointment": "Rendez-vous"
      },
      "priorities": {
        "low": "Faible",
        "medium": "Moyenne",
        "high": "Élevée",
        "urgent": "Urgente"
      },
      "actions": {
        "cancel": "Annuler",
        "delete": "Supprimer",
        "markComplete": "Marquer comme terminé",
        "editEvent": "Modifier l'événement"
      },
      "confirmations": {
        "cancelAppointment": "Annuler le rendez-vous \"{{title}}\" ?",
        "deleteEvent": "Supprimer l'événement \"{{title}}\" ?",
        "markComplete": "Marquer le rendez-vous \"{{title}}\" comme terminé ?"
      },
      "messages": {
        "appointmentCompleted": "Rendez-vous marqué comme terminé !",
        "appointmentUpdateFailed": "Échec de la mise à jour du rendez-vous",
        "appointmentUpdateError": "Erreur lors de la mise à jour du rendez-vous"
      }
    },
    "createModal": {
      "title": "Créer un nouvel événement",
      "fields": {
        "eventTitle": "Titre de l'événement",
        "eventTitlePlaceholder": "Saisir le titre de l'événement",
        "eventType": "Type d'événement",
        "startDate": "Date de début",
        "endDate": "Date de fin",
        "startTime": "Heure de début",
        "endTime": "Heure de fin",
        "allDayEvent": "Événement toute la journée",
        "priority": "Priorité",
        "description": "Description",
        "descriptionPlaceholder": "Saisir la description de l'événement (optionnel)"
      },
      "types": {
        "custom": "Personnalisé",
        "task": "Tâche",
        "deal": "Dossier",
        "lead": "Prospect",
        "appointment": "Rendez-vous"
      },
      "priorities": {
        "low": "Faible",
        "medium": "Moyenne",
        "high": "Élevée",
        "urgent": "Urgente"
      },
      "actions": {
        "cancel": "Annuler",
        "createEvent": "Créer l'événement"
      }
    },
    "months": {
      "january": "Janvier",
      "february": "Février",
      "march": "Mars",
      "april": "Avril",
      "may": "Mai",
      "june": "Juin",
      "july": "Juillet",
      "august": "Août",
      "september": "Septembre",
      "october": "Octobre",
      "november": "Novembre",
      "december": "Décembre"
    },
    "days": {
      "sun": "Dim",
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mer",
      "thu": "Jeu",
      "fri": "Ven",
      "sat": "Sam"
    },
    "checkingAvailability": "Vérification des disponibilités..."
  },
  "user": {
    "administrator": "Administrateur",
    "mortgageBroker": "Courtier hypothécaire",
    "user": "Utilisateur",
    "signOut": "Se déconnecter",
    "collapseMenu": "Réduire le menu",
    "expandMenu": "Développer le menu"
  },
  "table": {
    "lead": "PROSPECT",
    "contactInfo": "INFORMATIONS DE CONTACT",
    "status": "STATUT",
    "urgency": "URGENCE",
    "priority": "PRIORITÉ",
    "tasks": "TÂCHES",
    "created": "CRÉÉ",
    "assignedTo": "ASSIGNÉ À",
    "actions": "ACTIONS",
    "unassigned": "Non assigné",
    "by": "par"
  },
  "auth": {
    "login": "Connexion",
    "register": "Inscription",
    "logout": "Déconnexion",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "email": "Courriel",
    "phone": "Téléphone",
    "password": "Mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "loginButton": "Se connecter",
    "registerButton": "Créer un compte",
    "welcomeBack": "Bon retour",
    "createAccount": "Créer votre compte",
    "alreadyHaveAccount": "Vous avez déjà un compte?",
    "dontHaveAccount": "Vous n'avez pas de compte?",
    "signInHere": "Connectez-vous ici",
    "signUpHere": "Inscrivez-vous ici",
    "selectLanguage": "Sélectionnez votre langue préférée",
    "english": "English",
    "french": "Français",
    "recentlyLoggedIn": "Récemment connectés",
    "clickToContinue": "Cliquez sur votre compte pour continuer",
    "passkeyEnabled": "Clé d'accès activée",
    "sms2faEnabled": "SMS 2FA activé",
    "authAppEnabled": "App d'authentification activée",
    "loginDifferentAccount": "Se connecter à un autre compte",
    "signInWithPasskey": "Se connecter avec une clé d'accès",
    "choosePasskeys": "Choisissez parmi vos clés d'accès enregistrées",
    "backToRecentAccounts": "Retour aux comptes récents",
    "authenticating": "Authentification...",
    "backToHome": "Retour à l'accueil",
    "enterPasswordToContinue": "Entrez votre mot de passe pour continuer",
    "sessionExpiredPleaseLogin": "Votre session a expiré. Veuillez vous reconnecter."
  },
  "welcome": {
    "step1": {
      "title": "Bienvenue sur MortgageFlow!",
      "description": "Nous sommes ravis de vous accueillir. Commençons avec tout ce dont vous avez besoin pour gérer efficacement votre entreprise de courtage hypothécaire."
    },
    "step2": {
      "title": "Démarrez votre essai gratuit",
      "description": "Obtenez un accès complet à notre plan Premium pendant 30 jours - complètement gratuit! Aucune carte de crédit requise. Explorez toutes les fonctionnalités et découvrez comment MortgageFlow peut transformer votre entreprise."
    },
    "actions": {
      "next": "Suivant",
      "back": "Retour",
      "startTrial": "Démarrer l'essai gratuit",
      "starting": "Démarrage..."
    },
    "features": {
      "fullAccess": {
        "title": "Accès complet",
        "description": "Toutes les fonctionnalités premium débloquées"
      },
      "noPayment": {
        "title": "Aucun paiement",
        "description": "Aucune carte de crédit requise"
      },
      "thirtyDays": {
        "title": "30 jours",
        "description": "Annulez à tout moment, sans engagement"
      }
    }
  },
  "onboarding": {
    "stepProgress": "Étape {{current}} sur {{total}}",
    "welcome": {
      "title": "Bienvenue sur MortgageFlow!",
      "personalizedTitle": "Bienvenue, {{name}}!",
      "description": "Nous sommes ravis de vous accueillir. Prenons quelques instants pour configurer votre compte et bien démarrer.",
      "feature1Title": "Optimisez votre flux de travail",
      "feature1Description": "Gérez les dossiers, clients et tâches au même endroit",
      "feature2Title": "Développez votre entreprise",
      "feature2Description": "Suivez les performances et prenez des décisions éclairées"
    },
    "profile": {
      "title": "Configurez votre profil public",
      "description": "Configurez les informations professionnelles qui seront affichées publiquement aux clients et partenaires. Cliquez sur n'importe quel champ pour le modifier directement.",
      "professionalTitle": "Courtier hypothécaire",
      "traineeTitle": "Courtier hypothécaire (Stagiaire)",
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Courriel",
      "phone": "Téléphone",
      "brokerageFirm": "Cabinet de courtage",
      "brokerageFirmPlaceholder": "ex. Solutions Hypothécaires ABC Inc.",
      "isTrainee": "Je suis stagiaire",
      "traineeLabel": "Stagiaire",
      "pictureOptional": "Cliquez pour télécharger une photo",
      "pictureTooLarge": "L'image est trop volumineuse. Veuillez choisir un fichier de moins de 5 Mo.",
      "clickToEdit": "Cliquez pour modifier",
      "cropPhoto": "Recadrer et ajuster la photo",
      "saveFailed": "Échec de l'enregistrement de votre profil public. Veuillez réessayer."
    },
    "security": {
      "title": "Sécurisez votre compte",
      "description": "Choisissez une méthode de sécurité pour protéger votre compte. Nous recommandons d'utiliser une clé d'accès pour une meilleure expérience.",
      "pleaseSelectMethod": "Veuillez sélectionner une méthode de sécurité pour continuer",
      "deviceName": "Nom de l'appareil",
      "deviceNamePlaceholder": "ex. Mon iPhone, Ordinateur de travail",
      "defaultPasskeyName": "Mon appareil",
      "passkeyInstructions": "Cliquez sur Continuer et suivez les instructions de votre appareil pour configurer l'authentification biométrique.",
      "enterToken": "Veuillez entrer le code à 6 chiffres de votre application d'authentification",
      "invalidPhoneFormat": "Format de numéro de téléphone invalide. Utilisez le format international (ex. +14165551234)",
      "enterSmsCode": "Veuillez entrer le code à 6 chiffres envoyé à votre téléphone"
    },
    "trial": {
      "title": "Démarrez votre essai gratuit",
      "description": "Vous êtes prêt! Commencez votre essai gratuit de 30 jours et explorez tout ce que MortgageFlow a à offrir.",
      "freeTrialTitle": "Essai gratuit de 30 jours",
      "freeTrialDescription": "Accès complet à toutes les fonctionnalités premium - aucune carte de crédit requise!",
      "startFailed": "Échec du démarrage de l'essai. Veuillez réessayer."
    },
    "actions": {
      "back": "Retour",
      "continue": "Continuer",
      "cancel": "Annuler",
      "apply": "Appliquer",
      "startTrial": "Démarrer mon essai gratuit"
    }
  },
  "dashboard": {
    "title": "Tableau de bord",
    "welcome": "Bon retour",
    "adminTitle": "Tableau de bord administrateur",
    "adminDescription": "Aperçu des métriques et performances à l'échelle du système",
    "vsLastYear": "vs l'année dernière",
    "periods": {
      "today": "Aujourd'hui",
      "thisWeek": "Cette semaine",
      "thisMonth": "Ce mois-ci",
      "thisYear": "Cette année"
    },
    "dateFormats": {
      "weekdays": {
        "short": {
          "mon": "lun",
          "tue": "mar",
          "wed": "mer",
          "thu": "jeu",
          "fri": "ven",
          "sat": "sam",
          "sun": "dim"
        }
      },
      "months": {
        "short": {
          "jan": "jan",
          "feb": "fév",
          "mar": "mar",
          "apr": "avr",
          "may": "mai",
          "jun": "jun",
          "jul": "jul",
          "aug": "aoû",
          "sep": "sep",
          "oct": "oct",
          "nov": "nov",
          "dec": "déc"
        }
      }
    },
    "stats": {
      "totalCustomers": "Total des clients",
      "activeDealsPipeline": "Pipeline des dossiers actifs",
      "tasksToday": "Tâches d'aujourd'hui",
      "avgDealSize": "Taille moyenne des dossiers"
    },
    "todaysTasks": "Tâches d'aujourd'hui",
    "upcomingTasks": "Tâches à venir",
    "recentActivity": "Activité récente",
    "noTasks": "Aucune tâche pour aujourd'hui",
    "noUpcomingTasks": "Aucune tâche à venir",
    "widgets": {
      "leadOverview": "Aperçu des prospects",
      "pipelineValue": "Valeur du pipeline",
      "pipelineStatistics": "Statistiques du Pipeline",
      "taskOverview": "Aperçu des tâches",
      "funded": "Décaissé",
      "paid": "Payé",
      "submitted": "Soumis",
      "openRevenue": "Revenus ouverts",
      "inPipeline": "Dans le Pipeline",
      "newLeads": "Nouveaux prospects",
      "followUpsDue": "Relances dues",
      "hotLeads": "Prospects chauds",
      "conversionRate": "Taux de conversion",
      "byStatus": "Par statut",
      "recentActivity": "Activité récente",
      "today": "Aujourd'hui",
      "thisWeek": "Cette semaine",
      "overdue": "En retard",
      "totalActive": "Total actif",
      "needsAttention": "Nécessite une attention",
      "allCaughtUp": "Tout est à jour!",
      "totalFinancingAmount": "Montant total du financement",
      "activeDeals": "dossiers actifs",
      "activeFiles": "Dossiers actifs",
      "averageLoan": "Prêt moyen",
      "bankDistribution": "Répartition des banques",
      "moreBanks": "banques de plus",
      "expectedCommission": "Commission attendue",
      "yearlyStatistics": "Statistiques annuelles",
      "totalPaidCommission": "Commission totale payée",
      "totalLoanVolume": "Volume total de prêts",
      "leadConversionRate": "Taux de conversion des prospects",
      "leads": "prospects",
      "activitySummary": "Résumé d'activité",
      "leadsCreated": "Prospects créés",
      "dealsCreated": "Dossiers créés",
      "dealsCompleted": "dossiers complétés",
      "deals": "Dossiers",
      "financed": "Financé",
      "monthToDate": "Mois en cours",
      "yearToDate": "Année en cours",
      "averageBps": "BPS moyen",
      "bps": "pdb",
      "averageCommissionRate": "Taux de commission moyen",
      "lenderMetrics": "Métriques des prêteurs",
      "totalLenders": "Total de prêteurs",
      "majorityLender": "Prêteur majoritaire",
      "lastYear": "12 derniers mois",
      "ofDeals": "des dossiers",
      "retry": "Réessayer",
      "customizeDashboard": "Personnaliser le tableau de bord",
      "privacyMode": "Mode confidentialité",
      "showData": "Afficher les données",
      "addWidgets": "Ajouter des widgets",
      "alreadyAdded": "Déjà ajoutés",
      "addPipeline": "Pipeline",
      "addFunded": "Décaissé",
      "addSubmitted": "Soumis",
      "addOpenRevenue": "Revenus ouverts",
      "addPaid": "Payé",
      "addPipelineValue": "Valeur du pipeline",
      "addTaskOverview": "Aperçu des tâches",
      "addWhatsNew": "Quoi de neuf",
      "addLeadOverview": "Aperçu des prospects",
      "addYearlyStatistics": "Statistiques annuelles",
      "addAverageBps": "Points de base moyens",
      "addFeedback": "Commentaires",
      "addLenderMetrics": "Métriques des prêteurs",
      "addWorldClock": "Horloge mondiale",
      "worldClock": "Horloge mondiale",
      "selectTimezones": "Sélectionner fuseaux",
      "selectUpToFour": "Sélectionnez jusqu'à 4 fuseaux horaires",
      "businessHours": "Heures d'affaires",
      "afterHours": "Après les heures",
      "nightTime": "Heure de nuit",
      "statusWaiting": "En attente",
      "statusNew": "Nouveau",
      "statusCalled": "Appelé",
      "whatsNew": "Quoi de neuf",
      "latestUpdates": "Dernières mises à jour",
      "by": "par",
      "feedback": "Commentaires",
      "feedbackPlaceholder": "Partagez vos commentaires, suggestions ou demandes de fonctionnalités...",
      "characters": "caractères",
      "sendFeedback": "Envoyer les commentaires",
      "submitting": "Envoi en cours...",
      "feedbackSuccess": "Merci! Vos commentaires ont été soumis.",
      "feedbackError": "Échec de l'envoi des commentaires. Veuillez réessayer.",
      "feedbackRequired": "Veuillez entrer vos commentaires avant de soumettre.",
      "feedbackAuthError": "Vous devez être connecté pour soumettre des commentaires.",
      "feedbackHelper": "Vos commentaires nous aident à améliorer MortgageFlow Pro!"
    },
    "announcements": {
      "types": {
        "feature": "Nouvelle fonctionnalité",
        "improvement": "Amélioration",
        "bug_fix": "Correction de bogue",
        "maintenance": "Maintenance"
      },
      "newAnnouncement": "Nouvelle annonce",
      "continueReading": "Continuer la lecture",
      "viewAllAnnouncements": "Voir toutes les annonces",
      "pageTitle": "Quoi de neuf",
      "pageSubtitle": "Restez informé des dernières fonctionnalités, améliorations et annonces",
      "noAnnouncementsTitle": "Aucune annonce pour le moment",
      "noAnnouncementsMessage": "Revenez plus tard pour des mises à jour et de nouvelles fonctionnalités!",
      "footerMessage": "Vous avez des commentaires ou des suggestions? Nous aimerions vous entendre!"
    },
    "search": {
      "placeholder": "Rechercher des clients, dossiers, prospects, commentaires... (⌘K)",
      "searchCustomersDealsLeadsComments": "Rechercher des clients, dossiers, prospects, commentaires... (⌘K)",
      "searching": "Recherche en cours...",
      "commentIn": "Commentaire dans {{title}}",
      "viewAllResults": "Voir les {{count}} résultats pour \"{{query}}\"",
      "noResults": "Aucun résultat pour \"{{query}}\"",
      "tryDifferent": "Essayez d'autres mots-clés ou vérifiez l'orthographe",
      "recentSearches": "Recherches récentes",
      "startTyping": "Commencez à taper pour rechercher..."
    },
    "greeting": {
      "morning": "Bonjour {firstName}! Prêt à conquérir le marché hypothécaire?|Salut {firstName}! Une nouvelle journée de succès vous attend!|Bonjour {firstName}! C'est parti pour une journée légendaire!|Hey {firstName}, le matin est là—commençons par fermer ces dossiers!|Bonjour {firstName}! Prêt à transformer des prospects en clients?|Salut {firstName}! Une nouvelle journée de courtage vous attend!|Bonjour {firstName}! C'est l'heure de briller dans le courtage!|Hey {firstName}, le matin est parfait pour des victoires!|Bonjour {firstName}! Prêt à faire des affaires extraordinaires?|Salut {firstName}! Une journée de succès hypothécaire commence!",
      "day": "Salut {firstName}! L'après-midi est parfait pour des victoires!|Hey {firstName}, l'énergie de midi—fermons ces dossiers!|{firstName}, l'après-midi est là—c'est l'heure de briller!|Salut {firstName}! L'énergie de la journée—transformons ces prospects!|Hey {firstName}, l'après-midi est parfait pour des succès!|{firstName}, l'énergie de midi—fermons ces prêts!|Salut {firstName}! L'après-midi est là—c'est l'heure des victoires!|Hey {firstName}, l'énergie de la journée—brillons dans le courtage!|{firstName}, l'après-midi est parfait pour des affaires!|Salut {firstName}! L'énergie de midi—transformons ces clients!",
      "evening": "Bonsoir {firstName}! Il est temps de clôturer la journée avec une victoire!|Salut {firstName}, le soir est là—finissons ces dossiers en force!|{firstName}, excellent travail aujourd'hui! Finissons ces détails!|Bonsoir {firstName}! Une dernière poussée pour rendre cette journée légendaire!|Salut {firstName}, la journée se termine—clôturons avec style!|{firstName}, le soir appelle—scellons ces derniers dossiers!|Bonsoir {firstName}! Finissons la journée avec succès!|Salut {firstName}, vous avez écrasé aujourd'hui—finissons en force!|{firstName}, le soir est là—il est temps de verrouiller ces derniers prêts!|Bonsoir {firstName}! Faisons de ce soir les meilleurs dossiers!"
    }
  },
  "customers": {
    "title": "Contacts",
    "subtitle": "Gérer vos clients et partenaires",
    "customersTab": "Clients",
    "partnersTab": "Partenaires",
    "addCustomer": "Ajouter un client",
    "addCustomerSubtitle": "Créer un nouveau profil client avec les informations de contact",
    "editCustomer": "Modifier le client",
    "editCustomerSubtitle": "Mettre à jour les informations et coordonnées du client",
    "customerProfile": "Profil client",
    "customerProfileSubtitle": "Voir les informations détaillées du client, notes, tâches et demandes hypothécaires",
    "backToList": "Retour à la liste",
    "customerDetails": "Détails du client",
    "noCustomers": "Aucun client trouvé",
    "searchPlaceholder": "Rechercher des clients...",
    "profile": "Profil",
    "deals": "Dossiers",
    "tasks": "Tâches",
    "conversations": "Conversations",
    "personalInfo": "Informations personnelles",
    "contact": "Contact",
    "notes": "Notes",
    "addNote": "Ajouter une note",
    "customerDeals": "Dossiers du client",
    "customerTasks": "Tâches du client",
    "customerConversations": "Conversations du client",
    "customerNotFound": "Client non trouvé",
    "customerNotFoundDescription": "Le client demandé n'a pas été trouvé ou n'existe plus.",
    "backToCustomers": "Retour à la liste",
    "createTask": "+ Créer une tâche",
    "close": "Fermer",
    "form": {
      "primaryCustomerInformation": "Informations du client principal",
      "firstName": "Prénom",
      "lastName": "Nom de famille",
      "emailAddress": "Adresse courriel",
      "phoneNumber": "Numéro de téléphone",
      "preferredLanguage": "Langue préférée",
      "customLink": "Lien personnalisé",
      "associatedCustomers": "Client(s) associé(s)",
      "associatedCustomersDescription": "Ajoutez des clients supplémentaires qui seront associés à ce client. Lorsque vous créez un client et ajoutez des clients associés, ils seront liés ensemble et apparaîtront dans la section \"Clients associés\" de chacun.",
      "addCustomer": "+ Ajouter",
      "removeCustomer": "Retirer",
      "editCustomer": "Modifier",
      "cancel": "Annuler",
      "createCustomer": "Créer le client",
      "createCustomers": "Créer les clients",
      "updateCustomer": "Mettre à jour le client",
      "saving": "Enregistrement...",
      "customerCreatedSuccess": "Client créé avec succès !",
      "customerUpdatedSuccess": "Client mis à jour avec succès !",
      "enterFirstName": "Entrez le prénom",
      "enterLastName": "Entrez le nom de famille",
      "enterEmail": "client@exemple.com",
      "enterPhone": "(555) 123-4567",
      "enterCustomLink": "https://exemple.com",
      "languageFrench": "Français (French)",
      "languageEnglish": "English",
      "required": "*",
      "referredBy": "Référé par",
      "enterReferredBy": "Entrez le nom du référent"
    },
    "tabs": {
      "overview": "Aperçu",
      "properties": "Propriétés",
      "associatedCustomers": "Clients associés",
      "notes": {
        "title": "Notes",
        "totalNotes": "notes au total",
        "noNotesFound": "Aucune note trouvée pour ce client",
        "addNote": "Ajouter une note"
      },
      "tasks": {
        "title": "Tâches",
        "totalTasks": "tâches au total",
        "noTasksFound": "Aucune tâche trouvée pour ce client",
        "due": "Échéance",
        "created": "Créé"
      },
      "deals": {
        "title": "Dossiers",
        "dealsCount": "dossiers",
        "noDealsFound": "Aucun dossier trouvé pour ce client",
        "amount": "Montant",
        "type": "Type",
        "created": "Créé"
      }
    },
    "sections": {
      "primaryContact": "Contact principal",
      "accountInformation": "Informations du compte",
      "recentActivity": "Activité récente"
    },
    "labels": {
      "preferredLanguage": "Langue préférée",
      "customLink": "Lien personnalisé",
      "associatedCustomers": "Clients associés",
      "customerSince": "Client depuis",
      "lastUpdated": "Dernière mise à jour"
    },
    "summaryCards": {
      "totalTasks": "Tâches totales",
      "pendingTasks": "Tâches en attente",
      "notes": "Notes",
      "associatedCustomers": "Clients associés"
    },
    "activity": {
      "task": "Tâche",
      "due": "Échéance"
    },
    "relationships": {
      "title": "Relations clients",
      "associations": "associations"
    },
    "table": {
      "name": "NOM",
      "email": "COURRIEL",
      "phone": "TÉLÉPHONE",
      "actions": "ACTIONS",
      "noPhone": "Aucun téléphone",
      "loadingCustomers": "Chargement des clients...",
      "retry": "Réessayer",
      "searchPlaceholder": "Recherche par nom, courriel ou téléphone...",
      "showing": "Affichage de {{count}} sur {{total}} clients",
      "allCustomers": "Tous les clients",
      "recentCustomers": "Clients récents",
      "noCustomersFound": "Aucun client trouvé",
      "noCustomersMatching": "Aucun client trouvé correspondant à \"{search}\"",
      "view": "Voir",
      "edit": "Modifier",
      "delete": "Supprimer",
      "deleting": "Suppression...",
      "viewAll": "Voir tous les {count} clients →"
    },
    "properties": {
      "title": "Portefeuille de propriétés",
      "subtitle": "Propriétés et détails hypothécaires de {customerName}",
      "addProperty": "Ajouter une propriété",
      "addFirstProperty": "Ajouter la première propriété",
      "tabs": {
        "allProperties": "Toutes les propriétés",
        "financedByUs": "Financées par nous",
        "rentalProperties": "Propriétés locatives"
      },
      "emptyState": {
        "noPropertiesFound": "Aucune propriété trouvée",
        "startBuilding": "Commencez à construire leur portefeuille de propriétés en ajoutant la première propriété.",
        "noPropertiesForTab": "Aucune propriété {tab} trouvée pour ce client."
      }
    },
    "propertyForm": {
      "title": {
        "addNew": "Ajouter une nouvelle propriété",
        "edit": "Modifier la propriété"
      },
      "tabs": {
        "basicInfo": "Informations de base",
        "mortgageDetails": "Détails hypothécaires",
        "propertyDetails": "Détails de la propriété",
        "rentalInfo": "Informations locatives",
        "automation": "Automatisation"
      },
      "sections": {
        "basicInfo": {
          "title": "Informations de base sur la propriété",
          "fields": {
            "propertyName": "Nom de la propriété",
            "propertyType": "Type de propriété",
            "address": "Adresse",
            "numberOfUnits": "Nombre d'unités",
            "status": "Statut",
            "propertyValue": "Valeur de la propriété",
            "purchasePrice": "Prix d'achat",
            "purchaseDate": "Date d'achat"
          },
          "placeholders": {
            "propertyName": "ex. Résidence principale, Propriété locative #1",
            "address": "Adresse complète de la propriété",
            "propertyValue": "Valeur estimée actuelle",
            "purchasePrice": "Prix d'achat original"
          },
          "options": {
            "propertyTypes": {
              "residential": "Résidentiel",
              "commercial": "Commercial",
              "multiFamily": "Multi-famille",
              "condo": "Condominium",
              "townhouse": "Maison de ville",
              "land": "Terrain"
            },
            "status": {
              "active": "Actif",
              "sold": "Vendu",
              "underRenovation": "En rénovation",
              "forSale": "À vendre"
            }
          }
        },
        "mortgageInfo": {
          "title": "Informations hypothécaires",
          "financedByUs": "Financé par nous",
          "fields": {
            "mortgageAmount": "Montant de l'hypothèque actuel",
            "originalMortgageAmount": "Montant hypothécaire original",
            "currentInterestRate": "Taux d'intérêt actuel",
            "amortizationYears": "Années d'amortissement",
            "termYears": "Durée du terme",
            "mortgageStartDate": "Date de début de l'hypothèque",
            "renewalDate": "Date de renouvellement",
            "lenderName": "Nom du prêteur",
            "mortgageType": "Type d'hypothèque",
            "paymentFrequency": "Fréquence de paiement",
            "monthlyPayment": "Paiement mensuel"
          },
          "options": {
            "mortgageTypes": {
              "fixed": "Fixe",
              "variable": "Variable",
              "hybrid": "Hybride"
            },
            "paymentFrequencies": {
              "monthly": "Mensuel",
              "biWeekly": "Bi-hebdomadaire",
              "weekly": "Hebdomadaire",
              "accelerated": "Accéléré"
            }
          }
        },
        "propertyDetails": {
          "title": "Détails de la propriété",
          "fields": {
            "bedrooms": "Chambres",
            "bathrooms": "Salles de bain",
            "squareFeet": "Pieds carrés",
            "yearBuilt": "Année de construction",
            "lotSize": "Taille du terrain",
            "lotSizeUnit": "Unité de taille du terrain",
            "annualPropertyTaxes": "Taxes foncières annuelles",
            "annualInsurance": "Assurance annuelle",
            "monthlyMaintenanceEstimate": "Estimation d'entretien mensuel",
            "notes": "Notes"
          },
          "options": {
            "lotSizeUnits": {
              "sqft": "Pieds carrés",
              "acres": "Acres",
              "hectares": "Hectares"
            }
          }
        },
        "rentalInfo": {
          "title": "Informations locatives",
          "isRentalProperty": "Propriété locative",
          "fields": {
            "monthlyRentalIncome": "Revenus locatifs mensuels",
            "annualPropertyTaxes": "Taxes foncières annuelles",
            "annualInsurance": "Assurance annuelle",
            "monthlyMaintenanceEstimate": "Estimation d'entretien mensuel"
          }
        },
        "automation": {
          "title": "Automatisation et rappels",
          "autoRenewalReminders": "Rappels automatiques de renouvellement",
          "renewalReminderMonths": "Mois avant le renouvellement",
          "autoRateReviewReminders": "Rappels automatiques de révision des taux",
          "rateReviewFrequencyMonths": "Fréquence de révision des taux",
          "options": {
            "renewalReminderMonths": {
              "6": "Tous les 6 mois",
              "12": "Tous les 12 mois",
              "24": "Tous les 24 mois"
            }
          }
        }
      },
      "buttons": {
        "cancel": "Annuler",
        "createProperty": "Créer la propriété",
        "updateProperty": "Mettre à jour la propriété",
        "saving": "Enregistrement..."
      },
      "error": "Erreur"
    }
  },
  "deals": {
    "title": "Dossiers",
    "subtitle": "Gérer votre pipeline de dossiers hypothécaires",
    "addDeal": "Ajouter un dossier",
    "createNewDeal": "Créer un nouveau dossier",
    "addDealDescription": "Ajouter un nouveau dossier hypothécaire à votre pipeline",
    "createDeal": "Créer le dossier",
    "editDeal": "Modifier le dossier",
    "dealDetails": "Détails du dossier",
    "dealName": "Nom du dossier",
    "dealCustomers": "Clients du dossier",
    "noCustomersYet": "Aucun client ajouté encore. Recherchez et ajoutez des clients ci-dessous.",
    "searchCustomersPlaceholder": "Rechercher et ajouter des clients par nom, courriel ou téléphone...",
    "descriptionPlaceholder": "Ajouter des notes supplémentaires sur ce dossier (optionnel)...",
    "noCustomersFound": "Aucun client trouvé",
    "createNewCustomer": "Créer un nouveau client",
    "applicant": "Demandeur",
    "coApplicant": "Co-demandeur",
    "associatedCustomersPrompt": {
      "title": "Ajouter les clients associés ?",
      "description": "{{customerName}} a {{count}} client(s) associé(s). Souhaitez-vous les ajouter à ce dossier en tant que co-demandeurs ?",
      "skip": "Ignorer",
      "addAll": "Ajouter tous comme co-demandeurs"
    },
    "loanAmount": "Montant du prêt",
    "commissionPoints": "Points de commission",
    "initialStatus": "Statut initial",
    "selectStatus": "Sélectionner un statut",
    "descriptionNotes": "Description et notes",
    "archivedDeals": "Dossiers archivés",
    "noArchivedDeals": "Aucun dossier archivé trouvé.",
    "noDeals": "Aucun dossier trouvé",
    "dealType": "Type de dossier",
    "selectDealType": "Sélectionner un type de dossier",
    "customer": "Client",
    "selectCustomer": "Sélectionner un client",
    "expectedCloseDate": "Date de clôture prévue",
    "commission": "Commission",
    "basePoints": "Points de base",
    "bonusPoints": "Points bonus",
    "volumePoints": "Points de volume",
    "closingDate": "Date de clôture",
    "pipeline": "Pipeline",
    "totalValue": "Valeur totale",
    "totalCommission": "Commission totale",
    "tableView": "Vue tableau",
    "hideEmptyStatuses": "Masquer les statuts vides",
    "showEmptyStatuses": "Afficher les statuts vides",
    "hide": "Masquer",
    "show": "Afficher",
    "emptyStatuses": "statuts vides",
    "noDealsInStatus": "Aucun dossier dans ce statut",
    "dealCount": "dossier",
    "dealCountPlural": "dossiers",
    "actions": "Actions",
    "editDeal": "Modifier le dossier",
    "dealName": "Nom du dossier",
    "customer": "Client",
    "amount": "Montant",
    "type": "Type",
    "netCommission": "Commission nette",
    "expectedClose": "Clôture prévue",
    "status": "Statut",
    "created": "Créé",
    "manage": "Gérer",
    "dealManagement": "Gestion des dossiers",
    "dealStatus": "Statut des dossiers",
    "dealTypesManagement": "Types de dossiers",
    "viewOptions": "Options d'affichage",
    "table": "Tableau",
    "cards": "Cartes",
    "compact": "Compact",
    "archive": "Archive",
    "viewArchived": "Voir les archivés",
    "columnSettings": {
      "title": "Paramètres des colonnes",
      "columnSettings": "Paramètres des colonnes",
      "subtitle": "Gérer les colonnes du tableau pour la vue des dossiers",
      "databaseIssue": "Problème de base de données : Migration de base de données requise - table custom_columns introuvable",
      "databaseError": "Erreur de base de données :",
      "databaseUnavailable": "Le service de base de données est actuellement indisponible. Les colonnes système fonctionnent toujours.",
      "customColumnsUnavailable": "Les colonnes personnalisées ne sont pas disponibles tant que la migration de base de données n'est pas exécutée.",
      "runDatabaseMigration": "Exécuter la migration de base de données",
      "resetToDefaults": "Réinitialiser aux valeurs par défaut",
      "addCustomColumn": "Ajouter une colonne personnalisée",
      "saveChanges": "Enregistrer les modifications",
      "availableColumns": "Colonnes disponibles",
      "totalColumns": "Colonnes totales",
      "visibleColumns": "Colonnes visibles",
      "customColumns": "Colonnes personnalisées",
      "system": "Système",
      "sortable": "Triable",
      "align": "Alignement",
      "left": "Gauche",
      "center": "Centre",
      "right": "Droite",
      "columnNames": {
        "dealName": "Nom du dossier",
        "customer": "Client",
        "amount": "Montant",
        "type": "Type",
        "netCommission": "Commission nette",
        "expectedClose": "Clôture prévue",
        "status": "Statut",
        "created": "Créé"
      },
      "columnTypes": {
        "text": "Texte",
        "number": "Nombre",
        "date": "Date",
        "dropdown": "Liste déroulante",
        "boolean": "Booléen (Oui/Non)"
      },
      "customColumnEditor": {
        "addTitle": "Ajouter une colonne personnalisée",
        "editTitle": "Modifier la colonne",
        "addSubtitle": "Créer une nouvelle colonne personnalisée pour vos dossiers",
        "editSubtitle": "Modifier les propriétés de la colonne",
        "columnName": "Nom de la colonne",
        "columnNameRequired": "Nom de la colonne *",
        "columnNamePlaceholder": "ex. Niveau de priorité",
        "columnKey": "Clé de colonne",
        "columnKeyRequired": "Clé de colonne *",
        "columnKeyPlaceholder": "ex. niveau_priorite",
        "columnKeyHelp": "Identifiant unique pour cette colonne (minuscules, tirets bas uniquement)",
        "columnType": "Type de colonne",
        "columnTypeRequired": "Type de colonne *",
        "dropdownOptions": "Options de liste déroulante",
        "dropdownOptionsRequired": "Options de liste déroulante *",
        "dropdownOptionsPlaceholder": "Entrez chaque option sur une nouvelle ligne :\nPriorité élevée\nPriorité moyenne\nPriorité faible",
        "dropdownOptionsHelp": "Entrez chaque option sur une nouvelle ligne. Vous pouvez modifier ces options plus tard.",
        "defaultValue": "Valeur par défaut",
        "defaultValuePlaceholder": "Valeur par défaut optionnelle",
        "noDefault": "-- Aucune valeur par défaut --",
        "yes": "Oui",
        "no": "Non",
        "textAlignment": "Alignement du texte",
        "visible": "Visible",
        "required": "Requis",
        "sortable": "Triable",
        "resizable": "Redimensionnable",
        "cancel": "Annuler",
        "createColumn": "Créer la colonne",
        "saveChanges": "Enregistrer les modifications",
        "validation": {
          "nameRequired": "Le nom de la colonne est requis",
          "keyRequired": "La clé de colonne est requise",
          "keyFormat": "La clé doit commencer par une lettre et contenir uniquement des lettres minuscules, des chiffres et des tirets bas",
          "keyExists": "Cette clé existe déjà",
          "dropdownMinOptions": "La liste déroulante doit avoir au moins 2 options",
          "dropdownUniqueOptions": "Les options de liste déroulante doivent être uniques"
        }
      }
    },
    "dealTypes": {
      "purchase": "Achat",
      "refinance": "Refinancement",
      "transfer": "Transfert",
      "other": "Autre"
    },
    "dealDetail": {
      "loading": "Chargement du dossier...",
      "errorLoading": "Erreur lors du chargement du dossier",
      "dealNotFound": "Dossier non trouvé",
      "dealNotFoundMessage": "Le dossier demandé n'a pas pu être trouvé.",
      "backToDeals": "Retour aux dossiers",
      "assignedTo": "Assigné à :",
      "referredBy": "Référé par",
      "manage": "Gérer",
      "assignTeam": "Assigner l'équipe",
      "tools": "Outils",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement...",
      "historyComments": "Commentaires",
      "sms": "SMS",
      "compliance": "Conformité",
      "complianceComingSoon": "Conformité à venir",
      "complianceDescription": "Cette section vous permettra de gérer les documents de conformité et les exigences pour ce dossier. Restez à l'écoute pour les mises à jour !",
      "commentType": "Type de commentaire",
      "voiceRecording": "Enregistrement vocal et transcription IA",
      "startRecording": "Commencer l'enregistrement",
      "addNoteOrComment": "Ajouter une note ou un commentaire",
      "addNotePlaceholder": "Ajoutez une note détaillée ou un commentaire... Appuyez sur Entrée pour de nouveaux paragraphes.",
      "addComment": "Ajouter un commentaire",
      "addingComment": "Ajout du commentaire...",
      "pinComment": "Épingler le commentaire",
      "unpinComment": "Désépingler le commentaire",
      "pinnedComment": "Épinglé",
      "toolsModal": {
        "title": "Outils et calculateurs de dossier",
        "subtitle": "Accès rapide aux outils et calculateurs utiles pour ce dossier",
        "noToolsYet": "Aucun outil disponible pour le moment",
        "noToolsDescription": "Des outils et calculateurs seront ajoutés ici prochainement pour vous aider à gérer ce dossier plus efficacement.",
        "comingSoon": "À venir",
        "exportPdf": {
          "title": "Exporter le résumé du dossier",
          "description": "Générer un rapport PDF complet avec tous les détails et commentaires du dossier",
          "selectLanguage": "Langue du rapport",
          "english": "Anglais",
          "french": "Français",
          "generating": "Génération du PDF...",
          "downloadPdf": "Télécharger le PDF"
        }
      },
      "associatedTasks": "Tâches associées",
      "currentTasks": "Tâches actuelles",
      "recentlyCompleted": "Récemment terminées",
      "noTasksAssociated": "Aucune tâche associée à ce dossier pour le moment.",
      "createTask": "Créer une tâche",
      "taskCreationError": "Échec de la création de la tâche. Veuillez réessayer.",
      "due": "Échéance :",
      "priority": "Priorité :",
      "complete": "Terminer",
      "completed": "Terminé",
      "commissionSummary": "Résumé de la commission",
      "commissionCalculation": "Calcul de la commission",
      "baseBps": "Base Bps",
      "bonusBps": "Bonus Bps",
      "volumeBps": "Volume Bps",
      "totalBps": "Total Bps",
      "totalPoints": "Points totaux",
      "grossCommission": "Commission brute",
      "agencyFee": "Frais d'agence",
      "closingFee": "Frais de clôture",
      "netCommission": "Commission nette",
      "commissionSplits": "Partages de commission",
      "addCommissionSplit": "Ajouter un partage",
      "editCommissionSplit": "Modifier le partage",
      "deleteCommissionSplit": "Supprimer le partage",
      "confirmDeleteSplit": "Êtes-vous sûr de vouloir supprimer ce partage de commission ?",
      "partner": "Partenaire",
      "selectPartner": "Sélectionner un partenaire",
      "searchPartner": "Rechercher un partenaire...",
      "createPartner": "Créer \"{{name}}\"",
      "noPartnerFound": "Aucun partenaire trouvé",
      "splitType": "Type de partage",
      "percentage": "Pourcentage",
      "fixedAmount": "Montant fixe",
      "splitValue": "Valeur du partage",
      "splitNotes": "Notes",
      "splitNotesPlaceholder": "Notes optionnelles sur ce partage de commission...",
      "calculatedAmount": "Montant calculé",
      "noCommissionSplits": "Aucun partage de commission",
      "addFirstSplit": "Ajoutez votre premier partage pour partager la commission avec des partenaires",
      "totalSplitAmount": "Montant total partagé",
      "brokerCommission": "Votre commission",
      "splitCreatedSuccess": "Partage de commission créé avec succès",
      "splitUpdatedSuccess": "Partage de commission mis à jour avec succès",
      "splitDeletedSuccess": "Partage de commission supprimé avec succès",
      "splitCreationError": "Échec de la création du partage de commission",
      "splitUpdateError": "Échec de la mise à jour du partage de commission",
      "splitDeleteError": "Échec de la suppression du partage de commission",
      "dealSummary": "Résumé du dossier",
      "dealId": "ID du dossier",
      "dealName": "Nom du dossier",
      "dealType": "Type de dossier",
      "dealVersion": "Version du dossier",
      "lender": "Prêteur",
      "searchLender": "Rechercher un prêteur...",
      "selectLender": "Sélectionner un prêteur",
      "createLender": "Créer \"{{name}}\"",
      "noLenderFound": "Aucun prêteur trouvé",
      "lenderRequired": "Le nom du prêteur est requis",
      "created": "Créé",
      "lastUpdated": "Dernière mise à jour",
      "expectedClose": "Clôture prévue",
      "actualClose": "Fermeture réelle",
      "notSpecified": "Non spécifié",
      "notSet": "Non défini",
      "commentTypes": {
        "comment": "Commentaire général",
        "internal_note": "Note interne",
        "call": "Appel",
        "text": "Texte/SMS",
        "email": "Courriel",
        "in_person": "En personne",
        "other": "Autre"
      },
      "statusChanges": {
        "assignedAsCollaborator": "assigné comme collaborateur",
        "removedFromCollaborator": "retiré de l'assignation de collaborateur",
        "statusChangedFrom": "Statut changé de",
        "to": "vers"
      },
      "assignments": {
        "manageDealAssignments": "Gérer les assignations de dossier",
        "currentAssignments": "Assignations actuelles",
        "addTeamMember": "Ajouter un membre d'équipe",
        "remove": "Supprimer",
        "collaborator": "Collaborateur",
        "primaryAssignee": "Assigné principal",
        "noTeamMembersAvailable": "Aucun membre d'équipe disponible. Invitez des collaborateurs depuis les Paramètres pour les assigner aux dossiers.",
        "allTeamMembersAssigned": "Tous les membres d'équipe disponibles sont déjà assignés à ce dossier.",
        "addAsCollaborator": "Ajouter comme collaborateur",
        "addAsPrimary": "Ajouter comme principal"
      },
      "archivedDealChangeStatus": "Dossier archivé - Changer le statut :",
      "selectStatus": "Sélectionner un statut",
      "archivedLabel": "(Archivé)",
      "selectNonArchivedToReopen": "Sélectionner un statut non-archivé pour réouvrir"
    },
    "defaultStatuses": {
      "assemblingDocumentation": "Assemblage des documents",
      "submission": "Soumission",
      "conditionsFullfilment": "Remplissage des conditions",
      "approved": "Approuvé",
      "funded": "Décaissé",
      "archive": "Archive"
    }
  },
  "tasks": {
    "title": "Tâches",
    "subtitle": "Gérer vos tâches de courtage hypothécaire en se concentrant sur aujourd'hui et la semaine à venir",
    "boardTitle": "Tableau de tâches",
    "tomorrow": "Demain",
    "loadingBoard": "Chargement du tableau de tâches...",
    "addTask": "Ajouter une tâche",
    "createTask": "Créer une tâche",
    "editTask": "Modifier la tâche",
    "taskDetails": "Détails de la tâche",
    "noTasks": "Aucune tâche trouvée",
    "createFirstTask": "Créez votre première tâche pour commencer",
    "dueDate": "Date d'échéance",
    "priority": "Priorité",
    "completed": "Complétée",
    "pending": "En attente",
    "overdue": "En retard",
    "archive": "Archive",
    "viewArchived": "Voir les archives",
    "later": "Plus tard",
    "expand": "Développer",
    "collapse": "Réduire",
    "moreTasks": "tâches supplémentaires",
    "board": "Tableau",
    "table": "Liste",
    "task": "Tâche",
    "associatedWith": "Associé à",
    "status": "Statut",
    "actions": "Actions",
    "dueToday": "Dû aujourd'hui",
    "upcoming": "À venir",
    "scheduled": "Planifié",
    "noDate": "Aucune date",
    "moreTasks": "tâches supplémentaires",
    "task": "tâche",
    "tasks": "tâches",
    "manage": "Gérer",
    "viewOptions": "Options d'affichage",
    "boardView": "Vue Tableau",
    "tableView": "Vue Liste",
    "calendarView": "Vue Calendrier",
    "filterByPriority": "Filtrer par priorité",
    "filterByDate": "Filtrer par date",
    "filterByType": "Filtrer par type",
    "allPriorities": "Toutes les priorités",
    "allDates": "Toutes les dates",
    "allTypes": "Tous les types",
    "thisWeek": "Cette semaine",
    "customers": "Clients",
    "leads": "Prospects",
    "deals": "Dossiers",
    "generalTasks": "Tâches générales",
    "resetFilters": "Réinitialiser les filtres",
    "priorities": {
      "low": "Faible",
      "medium": "Moyen",
      "high": "Élevé",
      "urgent": "Urgent"
    },
    "todaysTasks": "Tâches d'aujourd'hui",
    "upcomingTasks": "Tâches à venir",
    "modals": {
      "taskCompleted": "Tâche terminée ! 🎉",
      "scheduleFollowUp": "Planifier une tâche de suivi (Optionnel)",
      "followUpPlaceholder": "Quelle est la prochaine étape ?",
      "priorityLevel": "Niveau de priorité",
      "whenShouldBeDone": "Quand cela devrait-il être fait ?",
      "orPickDate": "Ou choisir une date :",
      "today": "Aujourd'hui",
      "tomorrow": "Demain",
      "skipFollowUp": "Ignorer le suivi pour simplement terminer",
      "justComplete": "Juste terminer",
      "completeAndFollowUp": "Terminer + Suivi",
      "pushBack": "Reporter",
      "createFollowing": "Créer un suivi",
      "close": "Fermer",
      "associatedWith": "Associé à",
      "created": "Créé",
      "customer": "Client",
      "willBeLinkedToDeal": "Sera lié au même dossier",
      "generalTask": "Tâche générale (non associée à un client, prospect ou dossier)",
      "loadingLeadDetails": "Chargement des détails du prospect...",
      "description": "Description",
      "dueDate": "Date d'échéance",
      "priority": "Priorité",
      "associatedWith": "Associé à",
      "created": "Créé",
      "quickTask": "Tâche rapide",
      "whatNeedsToBeDone": "Que faut-il faire ?",
      "searchCustomerOrLead": "Rechercher un client ou un prospect...",
      "customers": "Clients",
      "leads": "Prospects",
      "linkToDeal": "Lier à un dossier (optionnel) :",
      "whenIsThisDue": "Quand est-ce dû ?",
      "whenDue": "Quand est-ce dû ?",
      "today": "Aujourd'hui",
      "tomorrow": "Demain",
      "nextWeek": "Semaine prochaine",
      "orPickDate": "Ou choisir une date :",
      "setSpecificTime": "Définir une heure spécifique (bloquera le créneau du calendrier)",
      "time": "Heure :",
      "fifteenMinuteSlot": "Un créneau de 15 minutes sera bloqué pour les rendez-vous",
      "cmdEnterToCreate": "⌘ + Entrée pour créer rapidement",
      "cmdEnterHint": "⌘ + Entrée pour créer rapidement",
      "cancel": "Annuler",
      "createTask": "Créer la tâche",
      "pushBackTask": "Reporter la tâche",
      "currentTask": "Tâche actuelle :",
      "due": "Échéance :",
      "pushBackBy": "Reporter de :",
      "orChooseSpecificDate": "Ou choisir une date spécifique :",
      "newDueDate": "Nouvelle date d'échéance :",
      "createFollowingTask": "Créer une tâche de suivi",
      "basedOn": "Basé sur :",
      "taskDescription": "Description de la tâche",
      "taskDescriptionRequired": "Description de la tâche *",
      "whatNeedsToBeDoneNext": "Que faut-il faire ensuite ?",
      "dueIn": "Échéance dans :",
      "orChooseSpecificDate": "Ou choisir une date spécifique :",
      "dueDate": "Date d'échéance :",
      "lowPriority": "Priorité faible",
      "mediumPriority": "Priorité moyenne",
      "highPriority": "Priorité élevée",
      "oneDay": "1 jour",
      "threeDays": "3 jours",
      "sevenDays": "7 jours"
    },
    "completedTasks": "Tâches complétées"
  },
  "leads": {
    "title": "Prospects",
    "subtitle": "Gérer vos prospects et les convertir en clients",
    "addLead": "Ajouter un prospect",
    "addFirstLead": "Ajouter votre premier prospect",
    "noLeadsFound": "Aucun prospect trouvé",
    "getStarted": "Commencez par ajouter votre premier prospect pour commencer à suivre les clients potentiels.",
    "allStatuses": "Tous les statuts",
    "urgency": "Urgence",
    "allUrgencyLevels": "Tous les niveaux d'urgence",
    "searchPlaceholder": "Rechercher des prospects...",
    "task": "tâche",
    "tasks": "tâches",
    "bestContact": "Meilleur contact",
    "created": "Créé",
    "convert": "Convertir",
    "editLead": "Modifier le prospect",
    "addNewLead": "Ajouter un nouveau prospect",
    "viewTable": "Voir le tableau",
    "viewCards": "Voir les cartes",
    "status": "Statut",
    "days": "jours",
    "day": "jour",
    "unassigned": "Non assigné",
    "clickToViewDetails": "Cliquer pour voir les détails",
    "contactInformation": "Informations de contact",
    "leadDetails": "Détails du prospect",
    "description": "Description",
    "timeline": "Chronologie",
    "email": "Courriel",
    "phone": "Téléphone",
    "by": "par",
    "close": "Fermer",
    "followUp": "Suivi",
    "edit": "Modifier",
    "delete": "Supprimer",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "addTaskOptional": "Ajouter une tâche (optionnel)",
    "taskDescription": "Description de la tâche",
    "dueDate": "Date d'échéance",
    "priority": "Priorité",
    "low": "Faible",
    "medium": "Moyen",
    "high": "Élevé",
    "convertLead": "Convertir le prospect",
    "convertingLead": "Conversion du prospect",
    "completeRequiredInfo": "Compléter les informations requises",
    "customizeDeal": "Personnaliser le dossier",
    "taskManagement": "Gestion des tâches",
    "dealName": "Nom du dossier",
    "amount": "Montant",
    "expectedCloseDate": "Date de clôture prévue",
    "dealType": "Type de dossier",
    "dealStatus": "Statut du dossier",
    "selectDealType": "Sélectionner le type de dossier",
    "selectDealStatus": "Sélectionner le statut du dossier",
    "convertTasks": "Convertir les tâches associées en tâches client",
    "cancel": "Annuler",
    "update": "Mettre à jour",
    "createLead": "Créer le prospect",
    "followUpWithLead": "Suivi avec le prospect...",
    "pleaseProvideContact": "Veuillez fournir au moins un champ de contact (nom, courriel ou téléphone)",
    "failedToSaveLead": "Échec de la sauvegarde du prospect",
    "areYouSureDelete": "Êtes-vous sûr de vouloir supprimer ce prospect?",
    "failedToDeleteLead": "Échec de la suppression du prospect",
    "leadConvertedSuccessfully": "Prospect converti avec succès!",
    "failedToConvertLead": "Échec de la conversion du prospect",
    "pleaseFillMissingFields": "Veuillez remplir les champs requis manquants:",
    "dealCreatedAutomatically": "Un dossier sera créé automatiquement. Vous pouvez personnaliser les détails ci-dessous ou les laisser vides pour utiliser les valeurs par défaut.",
    "bestContactTime": "Meilleur moment de contact",
    "assignedTo": "Assigné à",
    "assignedOn": "Assigné le",
    "statusNew": "Nouveau",
    "statusCalled": "Appelé",
    "statusEmailed": "Envoyé par courriel",
    "statusWaiting": "En attente",
    "statusQualified": "Qualifié",
    "statusNotInterested": "Pas intéressé",
    "urgencyLow": "Faible",
    "urgencyMedium": "Moyen",
    "urgencyHigh": "Élevé",
    "updateLeadInfo": "Mettre à jour les informations et les détails de suivi du prospect",
    "captureNewLeadInfo": "Capturer les informations d'un nouveau prospect pour commencer le suivi",
    "firstNamePlaceholder": "Entrer le prénom",
    "lastNamePlaceholder": "Entrer le nom de famille",
    "emailPlaceholder": "courriel@exemple.com",
    "phonePlaceholder": "(555) 123-4567",
    "descriptionPlaceholder": "Ajouter des notes sur ce prospect...",
    "createFollowUpTask": "Créer optionnellement une tâche de suivi pour ce prospect",
    "source": "Provenance",
    "searchPartner": "Rechercher un partenaire...",
    "noPartnersFound": "Aucun partenaire trouvé",
    "createNewPartner": "Créer un nouveau partenaire",
    "addPartnerDetails": "Ajouter les coordonnées du partenaire",
    "agency": "Agence",
    "partnerNameRequired": "Le nom du partenaire est requis",
    "failedToCreatePartner": "Échec de la création du partenaire",
    "createPartner": "Créer le partenaire"
  },
  "conversations": {
    "title": "Messages",
    "addConversation": "Ajouter une conversation",
    "startRecording": "Commencer l'enregistrement",
    "stopRecording": "Arrêter l'enregistrement",
    "transcription": "Transcription",
    "summary": "Résumé",
    "noConversations": "Aucune conversation trouvée",
    "speakNow": "Parlez maintenant...",
    "transcribing": "Transcription en cours...",
    "generating": "Génération du résumé...",
    "conversationType": "Type de conversation",
    "general": "Général",
    "mortgageConsultation": "Consultation hypothécaire",
    "saveTranscription": "Enregistrer la transcription"
  },
  "partners": {
    "title": "Partenaires",
    "subtitle": "Gérer vos partenaires de référence et collaborateurs",
    "addPartner": "Ajouter un partenaire",
    "editPartner": "Modifier le partenaire",
    "backToList": "Retour à la liste",
    "partnerDetails": "Détails du partenaire",
    "noPartners": "Aucun partenaire trouvé",
    "searchPlaceholder": "Rechercher des partenaires...",
    "form": {
      "partnerInformation": "Informations du partenaire",
      "firstName": "Prénom",
      "lastName": "Nom de famille",
      "emailAddress": "Adresse courriel",
      "phoneNumber": "Numéro de téléphone",
      "agency": "Agence",
      "commissionCut": "Part de commission (%)",
      "cancel": "Annuler",
      "createPartner": "Créer le partenaire",
      "updatePartner": "Mettre à jour le partenaire",
      "saving": "Enregistrement...",
      "partnerCreatedSuccess": "Partenaire créé avec succès !",
      "partnerUpdatedSuccess": "Partenaire mis à jour avec succès !",
      "enterFirstName": "Entrez le prénom",
      "enterLastName": "Entrez le nom de famille",
      "enterEmail": "partenaire@exemple.com",
      "enterPhone": "(555) 123-4567",
      "enterAgency": "Nom de l'agence",
      "enterCommissionCut": "ex., 25",
      "required": "*",
      "optional": "(Optionnel)",
      "commissionCutHint": "Pourcentage de partage de commission"
    },
    "table": {
      "name": "NOM",
      "email": "COURRIEL",
      "phone": "TÉLÉPHONE",
      "agency": "AGENCE",
      "cut": "PART",
      "actions": "ACTIONS",
      "noPhone": "Pas de téléphone",
      "noEmail": "Pas de courriel",
      "noAgency": "Pas d'agence",
      "noCut": "Non défini",
      "loadingPartners": "Chargement des partenaires...",
      "retry": "Réessayer",
      "searchPlaceholder": "Rechercher par nom, courriel, agence ou téléphone...",
      "showing": "Affichage de {{count}} sur {{total}} partenaires",
      "allPartners": "Tous les partenaires",
      "recentPartners": "Partenaires récents",
      "noPartnersFound": "Aucun partenaire trouvé",
      "noPartnersMatching": "Aucun partenaire trouvé correspondant à \"{search}\"",
      "view": "Voir",
      "edit": "Modifier",
      "delete": "Supprimer",
      "deleting": "Suppression..."
    }
  },
  "scenarios": {
    "title": "Générateur de scénarios",
    "createScenario": "Créer un scénario",
    "scenarioName": "Nom du scénario",
    "propertyValue": "Valeur de la propriété",
    "downPayment": "Mise de fonds",
    "amortization": "Amortissement",
    "paymentFrequency": "Fréquence de paiement",
    "generateReport": "Générer le rapport",
    "exportPDF": "Exporter en PDF",
    "noScenarios": "Aucun scénario trouvé"
  },
  "settings": {
    "title": "Paramètres",
    "adminTitle": "Paramètres d'administration",
    "brokerDescription": "Personnalisez votre expérience de courtage hypothécaire",
    "adminDescription": "Gérer les configurations à l'échelle du système et les permissions utilisateur",
    "comingSoon": "Bientôt disponible",
    "welcomeTitle": "Bienvenue dans les paramètres",
    "welcomeMessage": "Sélectionnez un paramètre dans la barre latérale pour commencer",
    "sections": {
      "account": "Compte",
      "system": "Système",
      "users": "Utilisateurs et accès",
      "billing": "Facturation et paiements",
      "communication": "Communication",
      "analytics": "Analytique",
      "deals": "Dossiers",
      "tasks": "Tâches et flux de travail",
      "organization": "Organisation",
      "leads": "Prospects et formulaires",
      "schedule": "Horaire"
    },
    "adminNotice": "Avis administrateur",
    "adminNoticeText": "En tant qu'administrateur, vous avez accès aux paramètres à l'échelle du système et aux fonctionnalités de gestion des utilisateurs. Certaines options de configuration avancées sont encore en développement et seront disponibles dans les mises à jour futures.",
    "needHelp": "Besoin d'aide ?",
    "helpText": "Si vous avez besoin d'aide avec les paramètres ou avez des questions sur la configuration de votre système, notre équipe de support est là pour vous aider.",
    "contactSupport": "Contacter le support (Bientôt disponible)",
    "viewDocs": "Voir la documentation (Bientôt disponible)",
    "profile": "Profil utilisateur",
    "profileDesc": "Mettre à jour vos informations personnelles et préférences",
    "dealStatuses": "Statuts des dossiers",
    "dealStatusesDesc": "Gérer les statuts de votre pipeline de dossiers et flux de travail",
    "dealTypes": "Types de dossiers",
    "dealTypesDesc": "Configurer les types et catégories de dossiers hypothécaires",
    "financialSettings": "Paramètres financiers",
    "financialSettingsDesc": "Configurer les taux de commission, frais et suivi financier",
    "taskDelays": "Délais des tâches",
    "reminderOffsets": "Décalages de rappels",
    "twilioSettings": "Paramètres Twilio",
    "smsTemplates": "Modèles SMS",
    "agencyFeePercentage": "Pourcentage de frais d'agence",
    "closingFeeAmount": "Montant des frais de fermeture",
    "addStatus": "Ajouter un statut",
    "editStatus": "Modifier le statut",
    "addType": "Ajouter un type",
    "editType": "Modifier le type",
    "statusName": "Nom du statut",
    "statusNameFr": "Nom du statut (français)",
    "typeName": "Nom du type",
    "typeNameFr": "Nom du type (français)",
    "color": "Couleur",
    "position": "Position",
    "darkMode": "Mode sombre",
    "lightMode": "Mode clair",
    "languageSettings": "Paramètres de langue",
    "changeLanguage": "Changer de langue",
    "admin": {
      "systemConfig": {
        "title": "Configuration système",
        "description": "Gérer les configurations et paramètres globaux du système"
      },
      "userManagement": {
        "title": "Gestion des utilisateurs",
        "description": "Permissions utilisateur avancées et gestion des rôles"
      },
      "stripeConfig": {
        "title": "Configuration Stripe",
        "description": "Configurer le traitement des paiements Stripe et les paramètres API"
      },
      "membershipManagement": {
        "title": "Gestion des adhésions",
        "description": "Créer et gérer les niveaux d'adhésion et permissions"
      },
      "platformSettings": {
        "title": "Paramètres de plateforme",
        "description": "Configurer les fonctionnalités et intégrations à l'échelle de la plateforme"
      },
      "customerMigration": {
        "title": "Migration des noms de clients",
        "description": "Migrer les noms de clients d'un champ unique vers le format prénom/nom"
      },
      "announcements": {
        "title": "Annonces",
        "description": "Gérer les annonces \"Quoi de neuf\" et mises à jour de la plateforme"
      },
      "telnyxIntegration": {
        "title": "Intégration Telnyx (Admin)",
        "description": "Configurer l'API Telnyx, numéro SMS par défaut et messages de bienvenue"
      },
      "analytics": {
        "title": "Analyses et rapports",
        "description": "Configurer les analyses et rapports à l'échelle du système"
      },
      "smsAdminSettings": {
        "title": "Paramètres SMS",
        "description": "Configurer la messagerie SMS, messages de bienvenue, notifications de prospects et actions SMS"
      },
      "impersonate": "Impersonnifier l'utilisateur"
    },
    "taskManagement": {
      "title": "Gestion des tâches",
      "description": "Configurer les délais de tâches et paramètres de rappel"
    },
    "smsSettings": {
      "title": "Paramètres SMS",
      "description": "Configurer les préférences SMS et messagerie bidirectionnelle"
    },
    "phoneNumberManagement": {
      "title": "Gestion des numéros de téléphone",
      "description": "Achetez et gérez votre numéro de téléphone dédié pour les appels et les SMS",
      "adminDescription": "Gérer l'inventaire des numéros de téléphone et les affectations des utilisateurs"
    },
    "membershipManagement": {
      "title": "Gestion des adhésions",
      "description": "Gérer votre abonnement et informations de facturation"
    },
    "leadsManagement": {
      "title": "Gestion des prospects",
      "description": "Configurer les statuts de prospects, niveaux d'urgence et paramètres de formulaire personnalisé"
    },
    "usersManagement": {
      "title": "Gestion des utilisateurs",
      "description": "Inviter des collaborateurs et gérer les permissions d'équipe"
    },
    "workflowManagement": {
      "title": "Gestion des flux de travail",
      "description": "Créer et gérer des flux de travail automatisés pour vos dossiers par type et version",
      "templates": "Modèles",
      "createWorkflow": "Créer un flux de travail",
      "workflowTemplates": "Modèles de flux de travail",
      "templatesCreated": "{{count}} modèle créé",
      "templatesCreated_plural": "{{count}} modèles créés",
      "noWorkflowsYet": "Aucun flux de travail pour le moment",
      "noWorkflowsDescription": "Créez votre premier modèle de flux de travail pour commencer.",
      "steps": "{{count}} étape",
      "steps_plural": "{{count}} étapes",
      "edit": "Modifier",
      "duplicate": "Dupliquer",
      "toggleStatus": "Changer le statut",
      "delete": "Supprimer",
      "selectWorkflowTemplate": "Sélectionner un modèle de flux de travail",
      "selectDescription": "Choisissez un modèle de flux de travail à gauche pour afficher et modifier ses étapes.",
      "createNewWorkflow": "Créer un nouveau flux de travail",
      "addStep": "Ajouter une étape",
      "noWorkflowSteps": "Aucune étape de flux de travail",
      "noWorkflowStepsDescription": "Ajoutez votre première étape de flux de travail pour définir le processus.",
      "addFirstStep": "Ajouter la première étape",
      "start": "Début",
      "end": "Fin",
      "automations": "{{count}} automation",
      "automations_plural": "{{count}} automations",
      "dealVersions": {
        "commercial": "Commercial",
        "residential": "Résidentiel"
      },
      "createModal": {
        "title": "Créer un modèle de flux de travail",
        "workflowName": "Nom du flux de travail",
        "workflowNamePlaceholder": "ex. Flux de travail d'achat résidentiel",
        "dealType": "Type de dossier",
        "selectDealType": "Sélectionner un type de dossier",
        "dealVersion": "Version du dossier",
        "description": "Description",
        "descriptionPlaceholder": "Description optionnelle de ce flux de travail...",
        "cancel": "Annuler",
        "createButton": "Créer le flux de travail"
      },
      "messages": {
        "loadError": "Échec du chargement des données de flux de travail",
        "createSuccess": "Modèle de flux de travail créé avec succès",
        "createError": "Échec de la création du modèle de flux de travail",
        "updateSuccess": "Modèle de flux de travail mis à jour avec succès",
        "updateError": "Échec de la mise à jour du modèle de flux de travail",
        "deleteSuccess": "Modèle de flux de travail supprimé avec succès",
        "deleteError": "Échec de la suppression du modèle de flux de travail",
        "duplicateSuccess": "Modèle de flux de travail dupliqué avec succès",
        "stepCreateSuccess": "Étape de flux de travail créée avec succès",
        "stepUpdateSuccess": "Étape de flux de travail mise à jour avec succès",
        "stepDeleteSuccess": "Étape de flux de travail supprimée avec succès",
        "deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce modèle de flux de travail ? Cette action ne peut pas être annulée.",
        "templateCreated": "Modèle de flux de travail créé avec succès!",
        "configSaved": "Configuration sauvegardée avec succès!",
        "validationSaveError": "Échec de la sauvegarde des exigences de validation",
        "automationSaveError": "Échec de la sauvegarde des règles d'automatisation",
        "saveError": "Échec de la sauvegarde de la configuration"
      },
      "validation": {
        "title": "Validation",
        "description": "Champs obligatoires pour la transition de statut",
        "helpText": "Sélectionnez les champs du dossier qui doivent être remplis avant qu'un dossier puisse passer à ce statut. Ces validations seront appliquées lors du changement de statut.",
        "selectedFields": "{{count}} champs requis",
        "noFieldsRequired": "Aucun champ requis"
      },
      "automationRules": {
        "title": "Règles d'automatisation",
        "addRule": "Ajouter une règle"
      }
    },
    "statusRules": {
      "title": "Règles de statut de dossier",
      "description": "Ajouter des règles de validation et d'automatisation à vos statuts de dossier",
      "dealStatuses": "Statuts de dossier",
      "noStatuses": "Aucun statut trouvé",
      "selectStatus": "Sélectionner un statut de dossier pour voir et gérer ses règles",
      "rulesFor": "Règles pour",
      "rules": "règles",
      "addRule": "Ajouter une règle",
      "noRules": "Aucune règle configurée pour ce statut",
      "noRulesDesc": "Ajoutez des règles de validation et d'automatisation pour personnaliser votre flux de travail",
      "ruleCreated": "Règle créée avec succès",
      "createFailed": "Échec de la création de la règle",
      "createError": "Erreur lors de la création de la règle",
      "ruleUpdated": "Règle mise à jour avec succès",
      "updateFailed": "Échec de la mise à jour de la règle",
      "updateError": "Erreur lors de la mise à jour de la règle",
      "ruleDeleted": "Règle supprimée avec succès",
      "deleteFailed": "Échec de la suppression de la règle",
      "deleteError": "Erreur lors de la suppression de la règle",
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer cette règle?",
      "ruleToggled": "Règle basculée avec succès",
      "toggleError": "Erreur lors du basculement de la règle",
      "createRule": "Créer une règle",
      "editRule": "Modifier la règle",
      "ruleName": "Nom de la règle",
      "trigger": "Déclencheur",
      "requiredFields": "Champs requis",
      "customValidation": "Validation personnalisée",
      "validationMessage": "Message de validation",
      "automation": "Automatisation",
      "priority": "Priorité",
      "active": "Actif"
    },
    "customFormSettings": {
      "title": "Paramètres du formulaire personnalisé",
      "description": "Configurer la réservation de rendez-vous, les types de rendez-vous et les formulaires de prospects personnalisés"
    },
    "liveChat": {
      "title": "Gestion des tickets de support",
      "description": "Répondre aux demandes de support des courtiers et gérer les tickets"
    },
    "liveChatSettings": {
      "title": "Paramètres du système de support",
      "description": "Configurer les heures d'ouverture, les notifications et les réponses automatiques"
    },
    "brokerSupport": {
      "title": "Obtenir de l'aide",
      "description": "Demander de l'aide aux administrateurs de la plateforme"
    },
    "scheduleSettings": {
      "title": "Paramètres d'horaire",
      "description": "Configurez vos heures de disponibilité, vos congés et vos préférences de réservation pour les rendez-vous clients",
      "weeklyAvailability": "Disponibilité hebdomadaire",
      "weeklyAvailabilityTip": "Définissez vos heures d'ouverture habituelles pour chaque jour de la semaine. Les clients ne pourront prendre rendez-vous que pendant ces heures.",
      "vacationTitle": "Vacances et jours de fermeture spéciaux",
      "vacationTip": "Bloquez vos périodes de vacances, jours fériés ou jours de fermeture spéciaux. Ces dates ne seront pas disponibles pour les réservations des clients.",
      "bookingPreferences": "Préférences de réservation",
      "bookingPreferencesTip": "Configurez la période de réservation anticipée et le temps tampon entre les rendez-vous.",
      "days": {
        "monday": "Lundi",
        "tuesday": "Mardi",
        "wednesday": "Mercredi",
        "thursday": "Jeudi",
        "friday": "Vendredi",
        "saturday": "Samedi",
        "sunday": "Dimanche"
      },
      "closed": "Fermé",
      "addHours": "+ Ajouter des heures",
      "copyFrom": "Copier depuis...",
      "to": "à",
      "removeTimeSlot": "Supprimer la plage horaire",
      "addVacationPeriod": "Ajouter une période de vacances",
      "recurring": "Récurrent",
      "recurringAnnually": "Récurrent annuellement",
      "yearly": "annuellement",
      "monthly": "mensuellement",
      "removeVacationPeriod": "Supprimer la période de vacances",
      "name": "Nom",
      "namePlaceholder": "ex. Vacances de Noël, Congés d'été",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "cancel": "Annuler",
      "timezone": "Fuseau horaire",
      "bufferTime": "Temps tampon (minutes)",
      "bufferTimeHelp": "Temps entre les rendez-vous",
      "maxAdvanceBooking": "Réservation anticipée max (jours)",
      "maxAdvanceBookingHelp": "Jusqu'où les clients peuvent réserver",
      "minAdvanceBooking": "Réservation anticipée min (heures)",
      "minAdvanceBookingHelp": "Préavis minimum requis",
      "saveScheduleSettings": "Enregistrer les paramètres d'horaire",
      "saving": "Enregistrement...",
      "savedSuccess": "Paramètres d'horaire enregistrés avec succès !",
      "savedError": "Échec de l'enregistrement des paramètres d'horaire. Veuillez réessayer.",
      "copiedSchedule": "Horaire copié de {{from}} à {{to}}"
    }
  },
  "leadSettings": {
    "title": "Paramètres des prospects",
    "subtitle": "Configurez les statuts de prospects et les niveaux d'urgence pour votre système de gestion de prospects.",
    "leadStatuses": "Statuts des prospects",
    "urgencyLevels": "Niveaux d'urgence",
    "addStatus": "Ajouter un statut",
    "addUrgencyLevel": "Ajouter un niveau d'urgence",
    "editStatus": "Modifier le statut",
    "editUrgencyLevel": "Modifier le niveau d'urgence",
    "addNewStatus": "Ajouter un nouveau statut",
    "addNewUrgencyLevel": "Ajouter un nouveau niveau d'urgence",
    "noStatusesConfigured": "Aucun statut configuré. Ajoutez votre premier statut pour commencer.",
    "noUrgencyLevelsConfigured": "Aucun niveau d'urgence configuré. Ajoutez votre premier niveau d'urgence pour commencer.",
    "name": "Nom",
    "color": "Couleur",
    "statusName": "Nom du statut",
    "urgencyLevelName": "Nom du niveau d'urgence",
    "edit": "Modifier",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "create": "Créer",
    "update": "Mettre à jour",
    "saving": "Enregistrement...",
    "confirmDeleteStatus": "Êtes-vous sûr de vouloir supprimer ce statut ?",
    "confirmDeleteUrgency": "Êtes-vous sûr de vouloir supprimer ce niveau d'urgence ?",
    "statusCreatedSuccess": "Statut créé avec succès",
    "statusUpdatedSuccess": "Statut mis à jour avec succès",
    "statusDeletedSuccess": "Statut supprimé avec succès",
    "urgencyCreatedSuccess": "Niveau d'urgence créé avec succès",
    "urgencyUpdatedSuccess": "Niveau d'urgence mis à jour avec succès",
    "urgencyDeletedSuccess": "Niveau d'urgence supprimé avec succès",
    "failedToLoadSettings": "Échec du chargement des paramètres",
    "failedToSaveStatus": "Échec de l'enregistrement du statut",
    "failedToDeleteStatus": "Échec de la suppression du statut",
    "failedToSaveUrgency": "Échec de l'enregistrement du niveau d'urgence",
    "failedToDeleteUrgency": "Échec de la suppression du niveau d'urgence"
  },
  "voice": {
    "makeCall": "Passer un appel",
    "incomingCall": "Appel entrant",
    "answer": "Répondre",
    "decline": "Refuser",
    "endCall": "Terminer l'appel",
    "mute": "Couper le son",
    "unmute": "Rétablir le son",
    "calling": "Appel en cours...",
    "connected": "Connecté",
    "callEnded": "Appel terminé"
  },
  "validation": {
    "required": "Ce champ est obligatoire",
    "invalidEmail": "Veuillez entrer une adresse courriel valide",
    "invalidPhone": "Veuillez entrer un numéro de téléphone valide",
    "passwordTooShort": "Le mot de passe doit contenir au moins 6 caractères",
    "passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
    "invalidAmount": "Veuillez entrer un montant valide"
  },
  "messages": {
    "saved": "Enregistré avec succès",
    "deleted": "Supprimé avec succès",
    "updated": "Mis à jour avec succès",
    "created": "Créé avec succès",
    "savingError": "Erreur lors de l'enregistrement",
    "deletingError": "Erreur lors de la suppression",
    "loadingError": "Erreur lors du chargement",
    "networkError": "Erreur réseau. Veuillez réessayer.",
    "loginSuccess": "Connexion réussie",
    "logoutSuccess": "Déconnexion réussie",
    "registrationSuccess": "Inscription réussie"
  },
  "appointment": {
    "selectMeetingType": "Sélectionner le type de rendez-vous",
    "selectDateTime": "Sélectionner la date et l'heure",
    "yourDetails": "Vos coordonnées",
    "appointmentBooked": "Rendez-vous réservé!",
    "back": "Précédent",
    "next": "Suivant",
    "bookAppointment": "Réserver le rendez-vous",
    "booking": "Réservation en cours...",
    "loading": "Chargement...",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "Adresse courriel",
    "phone": "Numéro de téléphone",
    "notes": "Notes supplémentaires (optionnel)",
    "firstNamePlaceholder": "Prénom",
    "lastNamePlaceholder": "Nom",
    "emailPlaceholder": "Entrez votre adresse courriel",
    "phonePlaceholder": "Entrez votre numéro de téléphone",
    "notesPlaceholder": "Parlez-nous de vos besoins hypothécaires ou de toute question que vous pourriez avoir...",
    "duration": "Durée",
    "confirmationMessage": "Vous recevrez sous peu un courriel de confirmation avec tous les détails de la réunion et une invitation de calendrier.",
    "meetingDetails": "Détails de la réunion",
    "noAvailableTimes": "Aucun créneau disponible pour cette date",
    "selectDifferentDate": "Veuillez sélectionner une autre date",
    "selectDateFirst": "Sélectionnez une date pour voir les heures disponibles",
    "selectDatePrompt": "Sélectionnez une date pour voir les heures disponibles",
    "availableTimes": "Heures disponibles",
    "at": "à",
    "with": "Avec",
    "meetingType": "Type de rendez-vous",
    "dateTime": "Date et heure",
    "fillAllFields": "Veuillez remplir tous les champs requis",
    "rescheduleInfo": "Besoin de reporter? Contactez-nous ou consultez votre courriel de confirmation pour les options."
  },
  "customForm": {
    "howToBeContacted": "Comment souhaitez-vous être contacté?",
    "contactMeASAP": "Contactez-moi dès que possible",
    "contactMeASAPDesc": "Je vous recontacterai dans les plus brefs délais selon vos préférences",
    "scheduleAppointment": "Planifier un rendez-vous",
    "scheduleAppointmentDesc": "Choisissez une heure qui vous convient dans mon agenda",
    "optional": "(optionnel)",
    "atLeastOneField": "Au moins un champ est requis",
    "submitting": "Envoi en cours...",
    "requiredField": "Veuillez fournir au moins votre nom, courriel ou numéro de téléphone.",
    "selectPriority": "Veuillez sélectionner une priorité.",
    "brokerNotFound": "Courtier introuvable",
    "brokerNotFoundMessage": "Le profil du courtier demandé n'a pas pu être trouvé.",
    "errorTitle": "Erreur",
    "errorMessage": "Une erreur s'est produite lors de la soumission de vos informations. Veuillez réessayer ou me contacter directement.",
    "contactDirect": "Contactez-moi directement:",
    "poweredBy": "Propulsé par"
  },
  "customFormSettings": {
    "title": "Paramètres du formulaire personnalisé",
    "subtitle": "Configurez votre système de réservation de rendez-vous et vos formulaires de prospects personnalisés",
    "saving": "Enregistrement...",
    "saveChanges": "Enregistrer les modifications",
    "tabs": {
      "general": "Général",
      "contactForm": "Formulaire de contact",
      "appointments": "Rendez-vous"
    },
    "meetingTypes": {
      "title": "Types de rendez-vous",
      "tip": "Les types de rendez-vous définissent la durée et l'objectif des rendez-vous. Les clients choisiront parmi ces options lors de la réservation.",
      "addMeetingType": "Ajouter un type de rendez-vous",
      "noMeetingTypes": "Aucun type de rendez-vous configuré pour le moment.",
      "addFirstMeetingType": "Ajoutez votre premier type de rendez-vous pour activer la réservation.",
      "duration": "Durée",
      "bufferBefore": "Tampon avant",
      "bufferAfter": "Tampon après",
      "inactive": "Inactif",
      "edit": "Modifier",
      "delete": "Supprimer",
        "modal": {
          "addTitle": "Ajouter un nouveau type de rendez-vous",
          "editTitle": "Modifier le type de rendez-vous",
          "nameEn": "Nom (anglais) *",
          "nameFr": "Nom (français)",
          "nameEnPlaceholder": "ex., Consultation initiale",
          "nameFrPlaceholder": "ex., Consultation initiale",
          "descriptionEn": "Description (anglais)",
          "descriptionFr": "Description (français)",
          "descriptionEnPlaceholder": "Brève description de ce type de rendez-vous",
          "descriptionFrPlaceholder": "Brève description de ce type de rendez-vous",
          "durationMinutes": "Durée (minutes) *",
          "color": "Couleur",
          "bufferBefore": "Tampon avant (min)",
          "bufferAfter": "Tampon après (min)",
          "active": "Actif (disponible pour la réservation)",
          "cancel": "Annuler",
          "update": "Mettre à jour",
          "create": "Créer",
          "saving": "Enregistrement..."
        }
    },
    "designPresets": {
      "title": "Modèles de design",
      "tip": "Choisissez un modèle de design pour styliser rapidement votre formulaire personnalisé. Vous pouvez personnaliser les couleurs et le texte après avoir sélectionné un modèle.",
      "yourFormUrl": "URL de votre formulaire personnalisé:",
      "preview": "Aperçu",
      "saveConfiguration": "Enregistrer la configuration",
      "saving": "Enregistrement...",
      "custom": "Personnalisé",
      "customizeColors": "Personnalisez vos propres couleurs",
      "applyPreset": "Appliquer le modèle",
      "customizeColorsTitle": "Personnaliser les couleurs",
      "customizeColorsTip": "Personnalisez le schéma de couleurs de votre formulaire pour correspondre à votre image de marque. Les modifications s'appliquent immédiatement à votre formulaire en direct.",
      "colorLabel": "Couleur"
    },
    "textLabels": {
      "title": "Textes et étiquettes",
      "tip": "Personnalisez tous les textes et étiquettes affichés sur votre formulaire personnalisé. Support pour l'anglais et le français.",
      "formTitles": "Titres du formulaire",
      "titleEn": "Titre (anglais)",
      "titleFr": "Titre (français)",
      "subtitleEn": "Sous-titre (anglais)",
      "subtitleFr": "Sous-titre (français)",
      "buttonSuccessMessages": "Bouton et messages de succès",
      "submitButtonEn": "Bouton de soumission (anglais)",
      "submitButtonFr": "Bouton de soumission (français)",
      "successTitleEn": "Titre de succès (anglais)",
      "successTitleFr": "Titre de succès (français)",
      "successMessageEn": "Message de succès (anglais)",
      "successMessageFr": "Message de succès (français)",
      "fieldLabels": "Étiquettes des champs",
      "english": "Anglais",
      "french": "Français",
      "firstNameLabel": "Étiquette prénom",
      "lastNameLabel": "Étiquette nom",
      "emailLabel": "Étiquette email",
      "phoneLabel": "Étiquette téléphone",
      "messageLabel": "Étiquette message",
      "messagePlaceholder": "Texte d'aide message",
      "firstNameLabelFr": "Étiquette prénom",
      "lastNameLabelFr": "Étiquette nom",
      "emailLabelFr": "Étiquette email",
      "phoneLabelFr": "Étiquette téléphone",
      "messageLabelFr": "Étiquette message",
      "messagePlaceholderFr": "Texte d'aide message",
      "appointmentBookingLabels": "Étiquettes de réservation de rendez-vous",
      "selectMeetingType": "Sélectionner le type de rendez-vous",
      "selectDateTime": "Sélectionner la date et l'heure",
      "backButton": "Bouton précédent",
      "nextButton": "Bouton suivant",
      "selectMeetingTypeFr": "Sélectionner le type de rendez-vous",
      "selectDateTimeFr": "Sélectionner la date et l'heure",
      "backButtonFr": "Bouton précédent",
      "nextButtonFr": "Bouton suivant"
    },
    "brokerInfo": {
      "title": "Info du courtier",
      "tip": "Configurez votre titre professionnel et vos coordonnées pour le formulaire personnalisé.",
      "contactInfoNotice": {
        "title": "Coordonnées maintenant gérées dans les paramètres de profil",
        "description": "Vos coordonnées (nom, email, téléphone) affichées sur les formulaires personnalisés sont maintenant gérées dans",
        "link": "Paramètres du profil → Informations publiques"
      },
      "professionalTitle": "Titre professionnel",
      "titleEn": "Titre (anglais)",
      "titleFr": "Titre (français)"
    },
    "formFields": {
      "title": "Champs du formulaire",
      "tip": "Configurez les champs à afficher sur votre formulaire personnalisé et définissez votre URL personnalisée.",
      "customFormUrl": "URL du formulaire personnalisé",
      "customUrlSlug": "Identifiant d'URL personnalisé",
      "urlSlugHint": "Seuls les lettres, chiffres, traits d'union et tirets bas sont autorisés",
      "yourFormUrl": "URL de votre formulaire personnalisé:",
      "copy": "Copier",
      "fieldVisibility": "Visibilité des champs",
      "firstNameField": "Champ prénom",
      "firstNameFieldDesc": "Afficher le champ de saisie du prénom",
      "emailField": "Champ email",
      "emailFieldDesc": "Afficher le champ de saisie de l'email (recommandé)",
      "messageField": "Champ message",
      "messageFieldDesc": "Afficher le champ de texte pour le message"
    },
    "notifications": {
      "title": "SMS et notifications",
      "tip": "Configurez les modèles SMS pour les soumissions de prospects, les confirmations de rendez-vous et les rappels. Utilisez des variables pour personnaliser les messages.",
      "save": "Enregistrer les paramètres",
      "saving": "Enregistrement...",
      "saveSuccess": "Paramètres de notification enregistrés avec succès!",
      "saveError": "Échec de l'enregistrement des paramètres de notification",
      "availableVariables": "Variables disponibles",
      "var": {
        "customerName": "Nom complet du client",
        "customerPhone": "Numéro de téléphone du client",
        "customerEmail": "Adresse email du client",
        "message": "Message du client",
        "brokerName": "Votre nom",
        "meetingType": "Type de rendez-vous",
        "appointmentDate": "Date du rendez-vous",
        "appointmentTime": "Heure du rendez-vous",
        "reminderTime": "Temps avant le rendez-vous"
      },
      "leadSubmission": "SMS de soumission de prospect",
      "appointmentBroker": "Confirmation de rendez-vous - Courtier",
      "appointmentCustomer": "Confirmation de rendez-vous - Client",
      "reminderBroker": "Rappel de rendez-vous - Courtier",
      "reminderCustomer": "Rappel de rendez-vous - Client",
      "smsTemplateEn": "Modèle SMS (anglais)",
      "smsTemplateFr": "Modèle SMS (français)",
      "reminderSettings": "Paramètres de rappel",
      "enableReminders": "Activer les rappels de rendez-vous",
      "enableRemindersDesc": "Envoyer des notifications de rappel avant les rendez-vous",
      "minutesBefore": "Envoyer le rappel (minutes avant le rendez-vous)",
      "minutesBeforeDesc": "Par défaut: 120 minutes (2 heures)"
    },
    "messages": {
      "meetingTypeSaved": "Type de rendez-vous enregistré avec succès!",
      "meetingTypeDeleted": "Type de rendez-vous supprimé avec succès!",
      "configSaved": "Configuration enregistrée avec succès!",
      "errorSaving": "Erreur lors de l'enregistrement de la configuration",
      "errorLoading": "Erreur lors du chargement des paramètres",
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce type de rendez-vous?"
    }
  },
  "teamManagement": {
    "title": "Gestion d'équipe",
    "subtitle": "Système avancé de collaboration d'équipe et de gestion des permissions",
    "backToSettings": "Retour aux paramètres",
    "sendInvite": "Envoyer une invitation",
    "tabs": {
      "teamInvites": "Équipe et invitations",
      "permissionMatrix": "Matrice de permissions",
      "teamAnalytics": "Analyses d'équipe",
      "departments": "Départements"
    },
    "activeCollaborators": {
      "title": "Collaborateurs actifs",
      "noCollaborators": "Aucun collaborateur pour le moment",
      "noCollaboratorsDesc": "Commencez à constituer votre équipe en invitant des collaborateurs pour vous aider à gérer votre entreprise hypothécaire.",
      "sendFirstInvite": "Envoyer la première invitation",
      "tableHeaders": {
        "collaborator": "Collaborateur",
        "contact": "Contact",
        "permissions": "Permissions",
        "status": "Statut",
        "joined": "Rejoint"
      }
    },
    "pendingInvites": {
      "title": "Invitations en attente",
      "tableHeaders": {
        "phoneNumber": "Numéro de téléphone",
        "permissions": "Permissions",
        "status": "Statut",
        "expires": "Expire",
        "actions": "Actions"
      },
      "cancel": "Annuler",
      "confirmCancel": "Êtes-vous sûr de vouloir annuler cette invitation?"
    },
    "permissions": {
      "viewOnly": "Lecture seule",
      "editTasks": "Modifier les tâches",
      "editDeals": "Modifier les dossiers",
      "editCustomers": "Modifier les clients",
      "manageSms": "Gérer les SMS"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif",
      "suspended": "Suspendu",
      "pending": "En attente",
      "accepted": "Accepté",
      "expired": "Expiré",
      "cancelled": "Annulé"
    },
    "inviteModal": {
      "title": "Envoyer une invitation de collaborateur",
      "phoneNumber": "Numéro de téléphone",
      "phonePlaceholder": "+1 (555) 123-4567",
      "role": "Rôle du collaborateur",
      "roleDescription": "Choisissez un rôle prédéfini ou personnalisez les permissions ci-dessous",
      "permissionsTitle": "Permissions",
      "customizable": "(Personnalisable)",
      "viewOnlyDesc": "Lecture seule - Peut consulter toutes les données mais ne peut pas effectuer de modifications",
      "editTasksDesc": "Modifier les tâches - Peut créer, mettre à jour et gérer les tâches",
      "editDealsDesc": "Modifier les dossiers - Peut créer, mettre à jour et gérer les dossiers",
      "editCustomersDesc": "Modifier les clients - Peut créer, mettre à jour et gérer les clients",
      "manageSmsDesc": "Gérer les SMS - Peut envoyer et recevoir des messages SMS",
      "cancel": "Annuler",
      "sendInvite": "Envoyer l'invitation",
      "sending": "Envoi en cours...",
      "phoneRequired": "Le numéro de téléphone est requis",
      "error": "Échec de l'envoi de l'invitation"
    },
    "permissionMatrix": {
      "title": "Matrice de permissions avancée",
      "description": "Gérez les permissions granulaires pour chaque membre de l'équipe avec le système de permissions nucléaire."
    },
    "analytics": {
      "title": "Analyses de performance d'équipe",
      "description": "Aperçus en temps réel de l'activité de l'équipe, des métriques de performance et des modèles de collaboration."
    },
    "departments": {
      "title": "Gestion des départements et hiérarchie",
      "description": "Organisez votre équipe en départements avec des structures de rapports claires et des affectations de rôles."
    },
    "departmentManager": {
      "title": "Gestion des départements",
      "description": "Organisez votre équipe en départements avec une direction dédiée",
      "newDepartment": "Nouveau département",
      "createNewDepartment": "Créer un nouveau département",
      "editDepartment": "Modifier le département",
      "createDepartment": "Créer un département",
      "updateDepartment": "Mettre à jour le département",
      "departmentName": "Nom du département",
      "departmentNameRequired": "Nom du département *",
      "departmentNamePlaceholder": "ex. Équipe de vente",
      "description": "Description",
      "descriptionPlaceholder": "Brève description de ce département...",
      "departmentColor": "Couleur du département",
      "custom": "Personnalisé",
      "departmentLead": "Responsable du département",
      "noLeadAssigned": "Aucun responsable assigné",
      "teamMembers": "Membres de l'équipe",
      "cancel": "Annuler",
      "saving": "Enregistrement...",
      "deactivateConfirm": "Êtes-vous sûr de vouloir désactiver ce département ? Cela supprimera tous les membres du département.",
      "active": "Actif",
      "inactive": "Inactif",
      "created": "Créé",
      "noDepartmentsTitle": "Aucun département pour le moment",
      "noDepartmentsDescription": "Commencez par créer votre premier département pour organiser la structure et le flux de travail de votre équipe.",
      "createFirstDepartment": "Créer votre premier département",
      "editTooltip": "Modifier le département",
      "deactivateTooltip": "Désactiver le département",
      "failedToSave": "Échec de l'enregistrement du département"
    },
    "accessDenied": {
      "title": "Accès refusé",
      "message": "Seuls les courtiers hypothécaires peuvent accéder à la gestion des utilisateurs."
    },
    "advancedTeamManagement": {
      "title": "Gestion d'équipe avancée",
      "subtitle": "Gestion d'équipe complète avec permissions avancées, analyses et outils organisationnels",
      "inviteMember": "Inviter un membre",
      "bulkImport": "Importation groupée",
      "teamOverview": "Aperçu de l'équipe",
      "welcome": "Bienvenue dans la gestion d'équipe avancée",
      "welcomeDesc": "Gérez votre équipe avec des outils de niveau entreprise pour les permissions, les analyses et l'organisation",
      "granularPermissions": "Permissions granulaires",
      "granularPermissionsDesc": "Définissez des permissions spécifiques pour chaque membre de l'équipe avec notre matrice de permissions avancée",
      "analyticsDesc": "Suivez la performance, l'activité et l'engagement de l'équipe avec des analyses détaillées",
      "departmentStructure": "Structure des départements",
      "departmentStructureDesc": "Organisez votre équipe en départements avec une direction dédiée et une hiérarchie",
      "teamMembers": "Membres de l'équipe",
      "roleTemplates": "Modèles de rôles",
      "recentActivity": "Activité récente",
      "lastSevenDays": "7 derniers jours",
      "gettingStarted": "Commencer",
      "setupDepartments": "Configurer les départements",
      "setupDepartmentsDesc": "Organisez votre équipe en départements logiques avec une direction dédiée",
      "configurePermissions": "Configurer les permissions",
      "configurePermissionsDesc": "Utilisez la matrice de permissions pour définir des contrôles d'accès granulaires pour chaque membre de l'équipe",
      "createRoleTemplates": "Créer des modèles de rôles",
      "createRoleTemplatesDesc": "Construisez des modèles de permissions réutilisables pour les rôles courants dans votre organisation",
      "monitorAnalytics": "Surveiller les analyses",
      "monitorAnalyticsDesc": "Suivez la performance et l'engagement de l'équipe grâce à des analyses complètes",
      "accessRestricted": "Accès restreint",
      "noPermissionMessage": "Vous n'avez pas la permission d'accéder aux fonctionnalités de gestion d'équipe. Contactez votre administrateur pour obtenir l'accès."
    }
  },
  "userProfile": {
    "title": "Profil utilisateur",
    "description": "Gérez vos informations personnelles et la sécurité de votre compte",
    "tabs": {
      "accountInformation": "Informations du compte",
      "publicInformation": "Informations publiques",
      "changePassword": "Changer le mot de passe",
      "securityFeatures": "Fonctionnalités de sécurité"
    },
    "accountInformation": {
      "title": "Informations du compte",
      "description": "Gérez les détails privés de votre compte",
      "profilePicture": {
        "title": "Photo de profil",
        "choosePicture": "Choisir une photo",
        "maxSize": "Max 5 Mo. JPG, PNG, GIF pris en charge.",
        "cropPhoto": "Recadrer et ajuster la photo",
        "zoom": "Zoom",
        "apply": "Appliquer",
        "savePicture": "Enregistrer la photo",
        "removePicture": "Supprimer la photo",
        "cancel": "Annuler",
        "uploading": "Téléchargement...",
        "confirmRemove": "Êtes-vous sûr de vouloir supprimer votre photo de profil ?",
        "tooLarge": "La photo de profil doit faire moins de 5 Mo",
        "invalidType": "Veuillez sélectionner un fichier image",
        "uploadSuccess": "Photo de profil mise à jour avec succès !",
        "uploadError": "Échec du téléchargement de la photo de profil",
        "removeSuccess": "Photo de profil supprimée avec succès !",
        "removeError": "Échec de la suppression de la photo de profil"
      },
      "fields": {
        "firstName": "Prénom",
        "lastName": "Nom",
        "emailAddress": "Adresse email",
        "phoneNumber": "Numéro de téléphone"
      },
      "saveChanges": "Enregistrer les modifications",
      "saving": "Enregistrement...",
      "updateSuccess": "Informations du compte mises à jour avec succès !",
      "updateError": "Échec de la mise à jour des informations du compte",
      "loadError": "Échec du chargement du profil utilisateur"
    },
    "publicInformation": {
      "title": "Informations publiques",
      "description": "Ces informations sont visibles par les clients et apparaissent sur votre carte de visite",
      "fields": {
        "displayFirstName": "Prénom d'affichage",
        "displayLastName": "Nom d'affichage",
        "displayEmail": "Adresse email publique",
        "displayPhone": "Numéro de téléphone public",
        "brokerageFirmName": "Nom de la société de courtage",
        "isTrainee": "Je suis un courtier hypothécaire stagiaire"
      },
      "hint": "Ce sont les détails que les clients verront lorsque vous partagez vos coordonnées",
      "saveChanges": "Enregistrer les modifications",
      "saving": "Enregistrement...",
      "updateSuccess": "Informations publiques mises à jour avec succès !",
      "updateError": "Échec de la mise à jour des informations publiques",
      "loadError": "Échec du chargement des informations publiques"
    },
    "changePassword": {
      "title": "Changer le mot de passe",
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "confirmPassword": "Confirmer le nouveau mot de passe",
      "passwordRequirements": "Le mot de passe doit contenir au moins 8 caractères avec des majuscules, des minuscules et un chiffre",
      "changePassword": "Changer le mot de passe",
      "changing": "Modification...",
      "passwordMismatch": "Le nouveau mot de passe et la confirmation ne correspondent pas",
      "changeSuccess": "Mot de passe modifié avec succès !",
      "changeError": "Échec de la modification du mot de passe"
    },
    "securityFeatures": {
      "title": "Fonctionnalités de sécurité",
      "aboutTitle": "À propos des fonctionnalités de sécurité",
      "aboutDescription": "Renforcez la sécurité de votre compte avec les clés d'accès et l'authentification à deux facteurs. Ces fonctionnalités offrent des couches de protection supplémentaires au-delà de votre mot de passe.",
      "quickLogin": {
        "title": "Préférence de connexion rapide",
        "active": "Actif",
        "description": "Choisissez votre méthode de sécurité préférée pour la connexion rapide lorsque vous cliquez sur votre compte sur l'écran de connexion. Ce sera la première méthode proposée lorsque vous essayez de vous connecter.",
        "passkey": "Clé d'accès",
        "passkeyDescription": "Utilisez l'authentification biométrique (empreinte digitale, reconnaissance faciale)",
        "authenticatorApp": "Application d'authentification",
        "authenticatorDescription": "Utilisez un code à 6 chiffres de votre application d'authentification",
        "smsVerification": "Vérification SMS",
        "smsDescription": "Recevez un code par message texte",
        "noPreferenceNote": "Vous ne voulez pas de préférence de connexion rapide ? Vous pouvez toujours utiliser le formulaire de connexion standard.",
        "preferenceCleared": "Préférence de connexion rapide effacée",
        "preferenceUpdated": "Préférence de connexion rapide mise à jour avec succès !",
        "preferenceError": "Échec de la mise à jour de la préférence de connexion rapide",
        "preferenceSetLocally": "Préférence de connexion rapide définie (sera synchronisée lors du déploiement du backend)"
      },
      "passkeysNotSupported": {
        "title": "Clés d'accès non prises en charge",
        "message": "Votre navigateur ou appareil ne prend pas en charge les clés d'accès. Veuillez utiliser un navigateur moderne comme Chrome, Safari ou Firefox sur un appareil avec authentification biométrique."
      }
    },
    "accountDetails": {
      "title": "Détails du compte",
      "accountCreated": "Compte créé :",
      "lastUpdated": "Dernière mise à jour :"
    }
  },
  "security": {
    "secureYourAccount": "Sécurisez votre compte",
    "requiredForProtection": "Requis pour la protection du compte",
    "securitySetupRequired": "Configuration de sécurité requise",
    "securityPolicyMessage": "Pour protéger votre compte et vous conformer aux politiques de sécurité, vous devez configurer au moins une fonctionnalité de sécurité supplémentaire.",
    "chooseSecurityMethod": "Choisissez une méthode de sécurité",
    "passkeys": "Clés d'accès",
    "passkey": "Clé d'accès",
    "passkeyDescription": "Utilisez votre empreinte digitale, votre visage ou le code PIN de votre appareil pour vous connecter en toute sécurité",
    "passkeyVerifyDescription": "Utilisez votre authentification biométrique",
    "passkeyRecommended": "Clé d'accès (Recommandé)",
    "passkeySetupDescription": "Rapide et sécurisé avec l'authentification biométrique",
    "smsAuthentication": "Authentification SMS",
    "smsDescription": "Recevez des codes de vérification par SMS",
    "authenticatorApp": "Application d'authentification",
    "authenticatorDescription": "Utilisez Google Authenticator ou des applications similaires",
    "settingUp": "Configuration en cours...",
    "setupFeature": "Configurer {{feature}}",
    "noSecurityFeatures": "Aucune fonctionnalité de sécurité n'est disponible sur cet appareil.",
    "contactSupport": "Veuillez contacter le support pour obtenir de l'aide.",
    "setupFailed": "Échec de la configuration de la fonctionnalité de sécurité. Veuillez réessayer.",
    "setupError": "Une erreur s'est produite lors de la configuration",
    "mandatoryNote": "C'est obligatoire pour tous les comptes. Vous pouvez ajouter plus de fonctionnalités de sécurité plus tard dans les paramètres de votre profil.",
    "checkingSecurity": "Vérification de la sécurité...",
    "verificationRequired": "Vérification de sécurité requise",
    "chooseVerificationMethod": "Choisissez une méthode pour vérifier votre identité :",
    "enter6DigitCode": "Entrez votre code à 6 chiffres",
    "usePasskeyToVerify": "Utilisez votre clé d'accès pour vérifier votre identité",
    "verifying": "Vérification...",
    "verifyWithPasskey": "Vérifier avec la clé d'accès",
    "verify": "Vérifier",
    "enterCodeFromApp": "Entrez le code à 6 chiffres de votre application d'authentification :",
    "setupSecurityMessage": "Pour protéger votre compte, veuillez configurer au moins une fonctionnalité de sécurité :",
    "skipFor7Days": "Ignorer pendant 7 jours",
    "scanQRCode": "Scannez ce code QR avec votre application d'authentification :",
    "orManualSecret": "Ou entrez manuellement ce secret :",
    "enterCodeToVerify": "Entrez le code à 6 chiffres de votre application pour vérifier :",
    "verifyAndEnable2FA": "Vérifier et activer la 2FA",
    "2FAEnabledSuccess": "2FA activée avec succès !",
    "saveBackupCodes": "Enregistrez ces codes de secours dans un endroit sûr :",
    "continueToDashboard": "Continuer vers le tableau de bord",
    "sms2faVerification": "Vérification SMS",
    "receiveCodeViaSMS": "Recevoir le code par message texte",
    "enterSMSCode": "Entrez le code à 6 chiffres envoyé à votre téléphone",
    "sendingCode": "Envoi du code de vérification à votre téléphone...",
    "resendCode": "Renvoyer le code",
    "resendIn": "Renvoyer dans {{seconds}}s",
    "setupSuccessful": "Fonctionnalité de sécurité ajoutée !",
    "featureAddedMessage": "Votre compte est maintenant plus sécurisé !",
    "recommendMultipleFeatures": "Pour une sécurité maximale, pensez à ajouter une autre méthode d'authentification.",
    "addAnotherFeature": "Ajouter une autre fonctionnalité de sécurité",
    "useDifferentMethod": "Utiliser une méthode de sécurité différente",
    "cancelVerification": "Annuler la connexion"
  },
  "securityFeatureCards": {
    "active": "Actif",
    "passkeysDescription": "Les clés d'accès sont un moyen sécurisé et sans mot de passe de se connecter en utilisant l'authentification biométrique de votre appareil (empreinte digitale, visage ou tactile).",
    "addNewPasskey": "Ajouter une nouvelle clé d'accès",
    "passkeyPlaceholder": "ex. iPhone, Ordinateur portable, Yubikey",
    "registering": "Enregistrement...",
    "register": "Enregistrer",
    "noPasskeys": "Aucune clé d'accès enregistrée. Ajoutez-en une ci-dessus pour commencer!",
    "added": "Ajoutée",
    "lastUsed": "Dernière utilisation",
    "remove": "Supprimer",
    "twoFactorAuth": "Authentification à deux facteurs (2FA)",
    "enabled": "Activée",
    "twoFactorAuthDescription": "Ajoutez une couche de sécurité supplémentaire en exigeant un mot de passe à usage unique temporel de votre application d'authentification (comme Google Authenticator, Authy ou Microsoft Authenticator).",
    "settingUp": "Configuration en cours...",
    "enable2FA": "Activer la 2FA",
    "step1ScanQR": "Étape 1 : Scanner le code QR",
    "openAuthAppScan": "Ouvrez votre application d'authentification et scannez ce code QR :",
    "orManuallyEnterSecret": "Ou entrez manuellement cette clé secrète :",
    "step2EnterCode": "Étape 2 : Entrer le code de vérification",
    "enter6DigitCodeFromApp": "Entrez le code à 6 chiffres de votre application d'authentification :",
    "verifyAndEnable": "Vérifier et activer",
    "saveBackupCodesWarning": "Enregistrez ces codes de secours dans un endroit sûr. Vous pouvez les utiliser pour accéder à votre compte si vous perdez votre appareil d'authentification :",
    "copyCodes": "Copier les codes",
    "twoFactorActive": "L'authentification à deux facteurs est active",
    "disabling": "Désactivation...",
    "disable": "Désactiver",
    "sms2FA": "Authentification à deux facteurs par SMS",
    "sms2FADescription": "Recevez des codes de vérification par SMS sur votre téléphone mobile. Un moyen sûr et pratique de protéger votre compte.",
    "enableSMS2FA": "Activer la 2FA par SMS",
    "phoneNumber": "Numéro de téléphone",
    "phoneNumberPlaceholder": "ex. +1 438 555 1234",
    "phoneNumberHelper": "Entrez votre numéro de téléphone au format international (E.164)",
    "sendVerificationCode": "Envoyer le code de vérification",
    "verificationCodeSent": "Code de vérification envoyé à votre téléphone",
    "enterSMSCode": "Entrez le code à 6 chiffres de votre SMS :",
    "codePlaceholder": "000000",
    "resendCode": "Renvoyer le code",
    "resendCodeIn": "Renvoyer le code dans {{seconds}}s",
    "sms2FAActive": "L'authentification à deux facteurs par SMS est active",
    "registeredPhone": "Téléphone enregistré : {{phone}}",
    "disableSMS2FA": "Désactiver la 2FA par SMS",
    "confirmPasswordToDisable": "Entrez votre mot de passe pour désactiver la 2FA par SMS :",
    "passwordRequired": "Le mot de passe est requis",
    "invalidPhoneFormat": "Format de numéro de téléphone invalide. Utilisez le format E.164 (ex. +14385551234)"
  },
  "trial": {
    "badge": "Essai",
    "freeTrial": "Essai gratuit",
    "daysRemaining": "{days} jours restants",
    "clickToUpgrade": "Cliquez pour améliorer",
    "trialExpired": "Essai expiré",
    "upgrade": "Améliorer"
  },
  "dealStatusSettings": {
    "title": "Gestion des statuts de dossiers",
    "subtitle": "Gérez les statuts de votre pipeline de dossiers avec réorganisation par glisser-déposer et couleurs personnalisées",
    "backToSettings": "Retour aux paramètres",
    "addNewStatus": "Ajouter un nouveau statut",
    "pipelineStatuses": "Statuts du pipeline",
    "tip": "Astuce : Glissez et déposez les statuts pour réorganiser votre pipeline. L'ordre ici détermine comment ils apparaissent dans votre tableau de dossiers.",
    "statusName": "Nom du statut",
    "statusNamePlaceholder": "Saisir le nom du statut",
    "color": "Couleur",
    "selectColor": "Sélectionner une couleur",
    "lead": "Prospect",
    "closed": "Fermé",
    "compliance": "Conformité",
    "archived": "Archivé",
    "submitted": "Soumis",
    "editStatus": "Modifier le statut",
    "deleteStatus": "Supprimer le statut",
    "editSmsTemplate": "Modifier le modèle SMS",
    "setupSmsTemplate": "Configurer le modèle SMS",
    "noStatusesConfigured": "Aucun statut de dossier configuré pour le moment",
    "createFirstStatus": "Créer votre premier statut",
    "addNewStatus": "Ajouter un nouveau statut",
    "editStatus": "Modifier le statut",
    "saveChanges": "Enregistrer les modifications",
    "cancel": "Annuler",
    "deleteStatus": "Supprimer le statut",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce statut ?",
    "smsTemplates": "Modèles SMS",
    "englishTemplate": "Modèle anglais",
    "frenchTemplate": "Modèle français",
    "templatePlaceholder": "Saisissez votre modèle SMS...",
    "saveTemplates": "Enregistrer les modèles",
    "templatesSaved": "Modèles SMS enregistrés avec succès !",
    "failedToSaveTemplates": "Échec de l'enregistrement des modèles SMS",
    "configured": "Configuré",
    "notConfigured": "Non configuré",
    "statusProperties": "Propriétés du statut"
  },
  "dealTypesSettings": {
    "title": "Gestion des types de dossiers",
    "subtitle": "Gérez vos types de dossiers et catégories",
    "backToSettings": "Retour aux paramètres",
    "addDealType": "Ajouter un type de dossier",
    "availableDealTypes": "Types de dossiers disponibles",
    "dealTypeName": "Nom du type de dossier",
    "dealTypeNamePlaceholder": "Saisir le nom du type de dossier",
    "frenchName": "Nom français",
    "frenchNamePlaceholder": "Saisir le nom français (optionnel)",
    "supportsCommercial": "Supporte commercial",
    "supportsResidential": "Supporte résidentiel",
    "active": "Actif",
    "inactive": "Inactif",
    "commercial": "Commercial",
    "residential": "Résidentiel",
    "noDealTypesConfigured": "Aucun type de dossier configuré pour le moment",
    "createFirstDealType": "Créer votre premier type de dossier",
    "addDealType": "Ajouter un type de dossier",
    "editDealType": "Modifier le type de dossier",
    "deleteDealType": "Supprimer le type de dossier",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce type de dossier ?",
    "dealTypeNameRequired": "Le nom du type de dossier est requis",
    "dealTypeAdded": "Type de dossier ajouté avec succès !",
    "dealTypeUpdated": "Type de dossier mis à jour avec succès !",
    "dealTypeDeleted": "Type de dossier supprimé avec succès !",
    "failedToAddDealType": "Échec de l'ajout du type de dossier",
    "failedToUpdateDealType": "Échec de la mise à jour du type de dossier",
    "failedToDeleteDealType": "Échec de la suppression du type de dossier",
    "failedToLoadDealTypes": "Échec du chargement des types de dossiers"
  },
  "financialSettings": {
    "title": "Paramètres financiers",
    "description": "Configurer les calculs de commission et les frais de fermeture",
    "backToSettings": "Retour aux paramètres",
    "commissionConfiguration": "Configuration de la commission",
    "agencyFeePercentage": "Pourcentage de frais d'agence (%)",
    "agencyFeePercentageHint": "Pourcentage du montant du dossier (ex., 1,25 % du montant du prêt)",
    "closingFeeAmount": "Montant des frais de fermeture ($)",
    "closingFeeAmountHint": "Montant fixe ajouté à chaque commission de dossier",
    "saveFinancialSettings": "Enregistrer les paramètres financiers",
    "saving": "Enregistrement…",
    "commissionCalculator": "Calculateur de commission",
    "dealAmount": "Montant du dossier ($)",
    "commissionPoints": "Points de commission (100 = 1 %)",
    "calculatedPercentage": "Pourcentage calculé",
    "grossCommission": "Commission brute",
    "agencyFee": "Frais d'agence",
    "closingFee": "Frais de fermeture",
    "netCommission": "Commission nette",
    "currentConfiguration": "Configuration actuelle",
    "example": "Exemple",
    "net": "net",
    "tip": "Astuce : Comment ça fonctionne :",
    "tipPoints": "Les points sont calculés comme suit : 100 points = 1 %, donc 150 points = 1,5 %",
    "tipCalculation": "Commission brute = Montant du dossier × (Points ÷ 10 000)",
    "tipNetCalculation": "Commission nette = Brute - (Brute × % Frais d'agence) - Frais de fermeture",
    "tipOverride": "Vous pouvez remplacer les commissions individuelles de dossiers si nécessaire",
    "enterAmountAndPoints": "Entrez le montant du dossier et les points de commission pour voir le calcul",
    "agencyFeeTitle": "Frais d'agence",
    "agencyFeeSubtitle": "Pourcentage déduit de la commission brute",
    "ofGrossCommission": "de la commission brute",
    "agencyFeeExample": "Exemple : 1,25 % signifie que l'agence prend 1,25 % de la commission brute sur chaque dossier.",
    "closingFeesTitle": "Frais de fermeture par montant de prêt",
    "closingFeesSubtitle": "Définir des frais fixes différents selon le montant du prêt",
    "addTier": "Ajouter un palier",
    "fromAmount": "À partir de",
    "closingFeeColumn": "Frais de fermeture",
    "baseBadge": "base",
    "removeTier": "Supprimer le palier",
    "tierRangeUpTo": "S'applique aux dossiers de {{from}} à {{to}}",
    "tierRangeAndAbove": "S'applique aux dossiers de {{from}} et plus",
    "singleTierNote": "Palier unique — les mêmes frais de fermeture s'appliquent à tous les dossiers. Ajoutez des paliers pour différencier selon le montant du prêt.",
    "howItsCalculated": "Comment c'est calculé",
    "formulaGross": "**Brut** = Montant du prêt × (Points ÷ 10 000)",
    "formulaAgencyFee": "**Frais d'agence** = Brut × % Frais d'agence",
    "formulaClosingFee": "**Frais de fermeture** = frais fixe selon le palier du montant du prêt",
    "formulaNet": "**Net** = Brut − Frais d'agence − Frais de fermeture",
    "pointsNote": "100 points = 1 %, donc 150 points = 1,5 %",
    "firstTierMustBeZero": "Le premier palier doit commencer à 0 $.",
    "commissionCalculatorTitle": "Calculateur de commission",
    "loanAmount": "Montant du prêt",
    "points": "Points",
    "tierApplied": "Palier appliqué : à partir de {{from}} → {{fee}} frais de fermeture",
    "grossLabel": "Brut ({{pct}} %)",
    "agencyFeeLabel": "Frais d'agence ({{pct}} %)",
    "closingFeeLabel": "Frais de fermeture",
    "netCommissionLabel": "Commission nette",
    "enterAmountBreakdown": "Entrez un montant de prêt et des points pour voir le détail",
    "messages": {
      "settingsSaved": "Paramètres financiers enregistrés avec succès !",
      "failedToSave": "Échec de l'enregistrement des paramètres financiers",
      "failedToLoad": "Échec du chargement des paramètres financiers",
      "noAuthToken": "Aucun jeton d'authentification"
    }
  },
  "membership": {
    "title": "Adhésion",
    "subtitle": "Gérez votre abonnement, méthodes de paiement et factures",
    "backToSettings": "Retour aux paramètres",
    "page": {
      "subtitle": "Gérez votre abonnement via Stripe",
      "accessDenied": "Accès refusé",
      "brokerOnly": "Les paramètres d'adhésion sont réservés aux courtiers.",
      "loadError": "Impossible de charger les informations d'adhésion.",
      "currentPlan": "Plan actuel",
      "plan": "Plan",
      "noActivePlan": "Aucun plan actif",
      "perMonth": "/mois",
      "status": "Statut",
      "trialEnds": "Fin de l'essai",
      "accessUntil": "Accès jusqu'au",
      "nextRenewal": "Prochain renouvellement",
      "billing": "Facturation",
      "manageBilling": "Gérer la facturation",
      "opening": "Ouverture…",
      "refreshStatus": "Actualiser le statut",
      "stripeNote": "La gestion de l'abonnement, les changements de plan, les méthodes de paiement et les factures sont traités de façon sécurisée via Stripe.",
      "recentInvoices": "Factures récentes",
      "noInvoices": "Aucune facture pour l'instant",
      "date": "Date",
      "amount": "Montant",
      "downloadPdf": "Télécharger le PDF",
      "portalError": "Impossible d'ouvrir le portail de facturation. Veuillez contacter le support.",
      "portalRetry": "Impossible d'ouvrir le portail de facturation. Veuillez réessayer.",
      "statusTrialing": "Essai — {{days}} jours restants",
      "statusCanceling": "Annulation en fin de période",
      "statusInactive": "Inactif"
    },
    "accessDenied": "Accès refusé",
    "brokerOnly": "Cette page n'est disponible que pour les courtiers.",
    "subscriptionRequired": "Abonnement requis",
    "choosePlanBelow": "Choisissez un plan d'abonnement ci-dessous pour continuer à utiliser toutes les fonctionnalités.",
    "tabs": {
      "subscription": "Abonnement et utilisation",
      "billing": "Paiement et facturation",
      "invoices": "Factures"
    },
    "subscription": {
      "title": "Informations d'abonnement",
      "currentPlan": "Plan actuel",
      "noPlan": "Aucun plan",
      "status": "Statut",
      "inactive": "Inactif",
      "renewsOn": "Se renouvelle le",
      "cancelsOn": "S'annule le",
      "trialEndsOn": "Fin de l'essai gratuit",
      "nextPayment": "Prochain paiement",
      "willBeCharged": "sera facturé",
      "noUpcomingPayment": "Aucun paiement à venir",
      "accessUntil": "Accès jusqu'au",
      "availablePlans": "Plans disponibles",
      "perMonth": "/mois",
      "currentPlanBadge": "Plan actuel",
      "freeTrialDays": "{days} jours d'essai gratuit",
      "unlimited": "Illimité",
      "customers": "Clients",
      "deals": "Dossiers",
      "tasks": "Tâches",
      "choosePlan": "Choisir le plan",
      "downgrade": "Rétrograder",
      "cancelSubscription": "Annuler l'abonnement",
      "cancelDescription": "Annulez votre abonnement à tout moment. Vous conserverez l'accès jusqu'à la fin de votre période de facturation actuelle.",
      "cancelButton": "Annuler l'abonnement"
    },
    "payment": {
      "title": "Méthodes de paiement",
      "description": "Gérez vos cartes enregistrées",
      "addCard": "Ajouter une carte",
      "noPaymentMethods": "Aucune méthode de paiement",
      "addCardDescription": "Ajoutez une carte de crédit ou de débit pour gérer votre abonnement",
      "default": "Par défaut",
      "expired": "Expirée",
      "expires": "Expire",
      "addingCard": "Ajout de la carte...",
      "cardDetails": "Détails de la carte",
      "addPaymentMethod": "Ajouter une méthode de paiement",
      "securePayments": "🔒 Paiements sécurisés",
      "stripeSecurityNotice": "Vos informations de paiement sont stockées et traitées en toute sécurité par Stripe, pas par nous. Nous ne voyons ni ne stockons jamais les détails complets de votre carte."
    },
    "billing": {
      "title": "Adresse de facturation",
      "description": "Votre adresse de facturation pour les factures",
      "editAddress": "Modifier",
      "addAddress": "Ajouter",
      "noBillingAddress": "Aucune adresse de facturation",
      "addAddressDescription": "Ajoutez votre adresse de facturation pour les factures",
      "streetAddress": "Adresse",
      "aptSuite": "App., Bureau, etc. (Optionnel)",
      "city": "Ville",
      "province": "Province",
      "postalCode": "Code postal",
      "postalCodeHint": "Entrez avec ou sans espace",
      "saveAddress": "Enregistrer l'adresse",
      "billingAddressModal": "Adresse de facturation",
      "selectProvince": "Sélectionner..."
    },
    "invoices": {
      "title": "Historique des factures",
      "noInvoices": "Aucune facture pour le moment",
      "invoicesDescription": "Vos factures apparaîtront ici une fois que vous aurez un abonnement actif",
      "date": "Date",
      "amount": "Montant",
      "status": "Statut",
      "actions": "Actions",
      "download": "Télécharger",
      "paid": "Payée",
      "pending": "En attente",
      "failed": "Échouée"
    },
    "modals": {
      "cancelSubscription": "Annuler l'abonnement?",
      "cancelDescription": "Votre abonnement restera actif jusqu'à la fin de votre période de facturation actuelle. Après cela, vous perdrez l'accès aux fonctionnalités premium.",
      "yesCancelButton": "Oui, annuler",
      "keepSubscription": "Conserver l'abonnement",
      "canceling": "Annulation..."
    },
    "messages": {
      "planChanged": "Plan changé avec succès pour {plan}",
      "subscriptionSuccess": "🎉 Abonnement réussi au plan {plan} pour {price}/mois! Votre abonnement est maintenant actif.",
      "subscriptionSuccessGracePeriod": "✅ Abonnement réussi au plan {plan}! Puisque vous avez déjà payé pour cette période, vous ne serez pas facturé à nouveau jusqu'à votre prochaine date de facturation.",
      "subscriptionSuccessTrial": "🎁 Abonnement réussi au plan {plan}! Vous pouvez continuer à profiter de votre essai gratuit - vous serez facturé à la fin de votre période d'essai.",
      "subscriptionCancelled": "Abonnement annulé avec succès",
      "paymentMethodAdded": "Méthode de paiement ajoutée avec succès",
      "paymentMethodRemoved": "Méthode de paiement supprimée avec succès",
      "billingAddressSaved": "Adresse de facturation enregistrée avec succès",
      "failedToChangePlan": "Échec du changement de plan",
      "failedToCancelSubscription": "Échec de l'annulation de l'abonnement",
      "failedToRemovePaymentMethod": "Échec de la suppression de la méthode de paiement",
      "failedToSaveBillingAddress": "Échec de l'enregistrement de l'adresse de facturation",
      "failedToFetchMembership": "Échec de la récupération des informations d'abonnement",
      "confirmChangePlan": "Changer votre plan pour {plan} à {price}/mois?",
      "confirmRemovePaymentMethod": "Supprimer cette méthode de paiement?",
      "addPaymentMethodFirst": "Veuillez d'abord ajouter une méthode de paiement avant de souscrire à un plan payant."
    }
  },
  "emailSettings": {
    "title": "Intégration de messagerie",
    "subtitle": "Connectez Gmail, Outlook ou n'importe quel compte courriel à MortgageFlow",
    "connectNew": "Connecter un nouveau compte de messagerie",
    "connectDescription": "Connectez vos comptes de messagerie pour consulter et gérer les courriels directement dans MortgageFlow. Vos identifiants sont stockés en toute sécurité et nous n'accédons aux courriels qu'avec votre permission.",
    "connectGmail": "Connecter Gmail",
    "connectOutlook": "Connecter Outlook",
    "connectImap": "Connecter IMAP (N'importe quel courriel)",
    "connectedAccounts": "Comptes connectés",
    "noConnections": "Aucun compte de messagerie connecté pour le moment. Connectez Gmail, Outlook ou n'importe quel courriel via IMAP pour commencer.",
    "lastSync": "Dernière synchronisation",
    "neverSynced": "Jamais",
    "syncNow": "Synchroniser maintenant",
    "disconnect": "Déconnecter",
    "imapForm": {
      "title": "Connexion via IMAP",
      "description": "Fonctionne avec n'importe quel fournisseur de messagerie (Gmail, Outlook, Yahoo, etc.). Pour Gmail/Outlook, utilisez un mot de passe d'application au lieu de votre mot de passe habituel.",
      "emailLabel": "Adresse courriel",
      "emailPlaceholder": "votre.courriel@exemple.com",
      "passwordLabel": "Mot de passe / Mot de passe d'application",
      "passwordPlaceholder": "••••••••",
      "gmailAppPasswordHelp": "Pour Gmail : Créer un mot de passe d'application",
      "advancedSettings": "Paramètres avancés (Optionnel - détection automatique pour les fournisseurs courants)",
      "imapServerLabel": "Serveur IMAP",
      "imapServerPlaceholder": "imap.gmail.com",
      "portLabel": "Port",
      "portPlaceholder": "993",
      "useTls": "Utiliser TLS/SSL (Recommandé)",
      "connecting": "Connexion...",
      "connect": "Connecter",
      "cancel": "Annuler"
    },
    "messages": {
      "connectionSuccess": "{provider} connecté avec succès : {email}",
      "connectionError": "Erreur de connexion : {error}",
      "gmailConnectError": "Échec de la connexion à Gmail. Veuillez réessayer.",
      "outlookConnectError": "Échec de la connexion à Outlook. Veuillez réessayer.",
      "imapConnectError": "Échec de la connexion via IMAP. Veuillez vérifier vos identifiants.",
      "disconnectConfirm": "Êtes-vous sûr de vouloir déconnecter ce compte {provider} ? Tous les courriels synchronisés seront supprimés.",
      "disconnectSuccess": "Compte de messagerie déconnecté avec succès",
      "disconnectError": "Échec de la déconnexion du compte de messagerie",
      "syncStarted": "Synchronisation des courriels démarrée. Cela peut prendre quelques instants.",
      "syncError": "Échec du démarrage de la synchronisation des courriels",
      "loadError": "Échec du chargement des connexions de messagerie"
    },
    "errors": {
      "microsoftOAuthRequired": "Microsoft a désactivé l'authentification par mot de passe pour votre organisation. Veuillez utiliser le bouton 'Connecter Outlook' pour vous authentifier via OAuth, ou contactez votre administrateur informatique.",
      "gmailAppPasswordRequired": "Gmail nécessite un mot de passe d'application. Veuillez en créer un dans les paramètres de votre compte Google et réessayer.",
      "invalidCredentials": "Adresse courriel ou mot de passe invalide. Veuillez vérifier vos identifiants et réessayer.",
      "connectionTimeout": "Délai de connexion dépassé. Veuillez vérifier votre connexion Internet et réessayer.",
      "serverNotFound": "Serveur de messagerie introuvable. Veuillez vérifier vos paramètres IMAP dans les Paramètres avancés."
    },
    "info": {
      "title": "Comment ça fonctionne",
      "point1": "Les courriels sont synchronisés automatiquement toutes les 15 minutes",
      "point2": "Vous pouvez synchroniser manuellement à tout moment en cliquant sur le bouton d'actualisation",
      "point3": "Déconnectez-vous à tout moment pour arrêter la synchronisation. Vos courriels dans MortgageFlow seront supprimés."
    }
  },
  "legal": {
    "backToHome": "Retour à l'accueil",
    "privacy": {
      "title": "Politique de confidentialité",
      "lastUpdated": "Dernière mise à jour",
      "updateDate": "1er février 2026",
      "introduction": {
        "title": "Introduction",
        "p1": "MortgageFlow.pro (« nous », « notre » ou « nos ») s'engage à protéger votre vie privée et la confidentialité de vos informations personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez notre plateforme et nos services de courtage hypothécaire.",
        "p2": "En tant que plateforme au service des courtiers hypothécaires et de leurs clients, nous comprenons la nature sensible des informations financières et nous nous engageons à maintenir les normes les plus élevées en matière de protection des données et de confidentialité."
      },
      "collection": {
        "title": "Informations que nous collectons",
        "personal": {
          "title": "Informations personnelles des courtiers",
          "item1": "Informations de compte (nom, adresse courriel, numéro de téléphone, détails commerciaux)",
          "item2": "Titres professionnels et informations de licence",
          "item3": "Informations de paiement et de facturation",
          "item4": "Préférences de communication et paramètres"
        },
        "client": {
          "title": "Informations sur les clients saisies par les courtiers",
          "item1": "Coordonnées des clients (noms, adresses, numéros de téléphone, courriels)",
          "item2": "Informations financières relatives aux demandes hypothécaires",
          "item3": "Informations sur les propriétés et détails des transactions",
          "item4": "Documents et fichiers téléchargés sur la plateforme"
        },
        "usage": {
          "title": "Données d'utilisation et techniques",
          "item1": "Données de journal, adresses IP, type de navigateur et informations sur l'appareil",
          "item2": "Modèles d'utilisation, fonctionnalités consultées et données d'interaction",
          "item3": "Cookies et technologies de suivi similaires"
        }
      },
      "usage": {
        "title": "Comment nous utilisons vos informations",
        "item1": "Fournir, maintenir et améliorer notre plateforme de courtage hypothécaire",
        "item2": "Traiter les transactions et gérer les abonnements",
        "item3": "Envoyer des informations administratives, des mises à jour et des alertes de sécurité",
        "item4": "Répondre aux demandes et fournir un support client",
        "item5": "Analyser les modèles d'utilisation pour améliorer l'expérience utilisateur",
        "item6": "Se conformer aux obligations légales et aux exigences réglementaires",
        "item7": "Détecter, prévenir et traiter les problèmes techniques et les incidents de sécurité"
      },
      "security": {
        "title": "Sécurité des données",
        "p1": "Nous mettons en œuvre des mesures de sécurité standard de l'industrie pour protéger vos informations, notamment :",
        "item1": "Chiffrement de bout en bout pour la transmission de données (TLS/SSL)",
        "item2": "Stockage de données chiffré utilisant le chiffrement AES-256",
        "item3": "Authentification multifacteur (2FA) et support des clés d'accès",
        "item4": "Audits de sécurité réguliers et évaluations de vulnérabilité",
        "item5": "Contrôles d'accès stricts et accords de confidentialité des employés"
      },
      "sharing": {
        "title": "Partage et divulgation d'informations",
        "p1": "Nous ne vendons pas vos informations personnelles. Nous pouvons partager des informations uniquement dans les circonstances suivantes :",
        "item1": "Fournisseurs de services : Avec des fournisseurs de services tiers de confiance (processeurs de paiement, hébergement cloud, analyses) qui nous aident à exploiter notre plateforme",
        "item2": "Conformité légale : Lorsque requis par la loi, un processus juridique ou une demande gouvernementale",
        "item3": "Transferts commerciaux : Dans le cadre d'une fusion, d'une acquisition ou d'une vente d'actifs",
        "item4": "Avec votre consentement : Lorsque vous nous autorisez explicitement à partager des informations"
      },
      "rights": {
        "title": "Vos droits en matière de confidentialité",
        "p1": "Selon votre emplacement, vous pouvez avoir les droits suivants :",
        "item1": "Accès : Demander l'accès à vos informations personnelles",
        "item2": "Correction : Demander la correction de données inexactes ou incomplètes",
        "item3": "Suppression : Demander la suppression de vos informations personnelles",
        "item4": "Portabilité : Demander une copie de vos données dans un format structuré",
        "item5": "Objection : S'opposer à certains traitements de vos informations",
        "item6": "Retrait : Retirer le consentement lorsque le traitement est basé sur le consentement"
      },
      "cookies": {
        "title": "Cookies et technologies de suivi",
        "p1": "Nous utilisons des cookies et des technologies similaires pour améliorer votre expérience, analyser l'utilisation et mémoriser vos préférences. Vous pouvez contrôler les cookies via les paramètres de votre navigateur.",
        "p2": "Les cookies essentiels sont nécessaires au fonctionnement de la plateforme, tandis que les cookies d'analyse et de préférence peuvent être désactivés sans affecter les fonctionnalités principales."
      },
      "retention": {
        "title": "Conservation des données",
        "p1": "Nous conservons vos informations aussi longtemps que nécessaire pour fournir nos services, respecter les obligations légales, résoudre les litiges et appliquer nos accords. Lorsque les données ne sont plus nécessaires, nous les supprimons ou les anonymisons de manière sécurisée."
      },
      "changes": {
        "title": "Modifications de cette politique de confidentialité",
        "p1": "Nous pouvons mettre à jour cette politique de confidentialité périodiquement. Nous vous informerons des modifications importantes par courriel ou par un avis bien visible sur notre plateforme. Votre utilisation continue du service après les modifications constitue l'acceptation de la politique mise à jour."
      },
      "contact": {
        "title": "Nous contacter",
        "p1": "Si vous avez des questions concernant cette politique de confidentialité ou si vous souhaitez exercer vos droits en matière de confidentialité, veuillez nous contacter :",
        "email": "Courriel",
        "address": "Adresse",
        "addressValue": "Canada"
      }
    },
    "terms": {
      "title": "Conditions d'utilisation",
      "lastUpdated": "Dernière mise à jour",
      "updateDate": "1er février 2026",
      "introduction": {
        "title": "Introduction",
        "p1": "Bienvenue sur MortgageFlow.pro. Ces conditions d'utilisation (« Conditions ») régissent votre accès et votre utilisation de notre plateforme de courtage hypothécaire, de nos services et de nos logiciels (collectivement, le « Service »).",
        "p2": "MortgageFlow.pro fournit une plateforme logicielle complète conçue spécifiquement pour les courtiers hypothécaires afin de gérer leurs opérations commerciales, leurs relations clients, leurs pipelines de dossiers et leurs tâches administratives."
      },
      "acceptance": {
        "title": "Acceptation des conditions",
        "p1": "En créant un compte, en accédant ou en utilisant notre Service, vous acceptez d'être lié par ces Conditions. Si vous n'êtes pas d'accord avec une partie de ces Conditions, vous ne pouvez pas accéder ni utiliser notre Service. Si vous utilisez le Service au nom d'une organisation, vous déclarez avoir l'autorité de lier cette organisation à ces Conditions."
      },
      "service": {
        "title": "Description du service",
        "p1": "MortgageFlow.pro fournit une plateforme basée sur le cloud qui comprend :",
        "item1": "Gestion de la relation client (CRM) pour les clients hypothécaires",
        "item2": "Gestion et suivi des prospects",
        "item3": "Gestion du pipeline de dossiers avec étapes personnalisables",
        "item4": "Gestion des tâches et automatisation des flux de travail",
        "item5": "Outils de communication (SMS, courriel, appels)",
        "item6": "Calendrier et planification de rendez-vous",
        "item7": "Collaboration d'équipe et gestion des utilisateurs",
        "item8": "Formulaires personnalisés et processus d'admission",
        "item9": "Gestion et stockage de documents",
        "item10": "Résumés de conversations et informations alimentés par l'IA",
        "item11": "Rapports, analyses et calculs de commissions",
        "item12": "Capacités d'intégration (Calendly et autres outils)"
      },
      "accounts": {
        "title": "Comptes utilisateur et inscription",
        "p1": "Pour utiliser notre Service, vous devez créer un compte et fournir des informations exactes et complètes. Vous acceptez de :",
        "item1": "Maintenir la sécurité et la confidentialité de vos identifiants de compte",
        "item2": "Nous informer immédiatement de tout accès non autorisé ou violation de sécurité",
        "item3": "Être responsable de toutes les activités qui se produisent sous votre compte",
        "item4": "Fournir des titres professionnels et des informations de licence précis si requis"
      },
      "payment": {
        "title": "Abonnement et paiement",
        "freeTrial": {
          "title": "Essai gratuit",
          "p1": "Les nouveaux utilisateurs bénéficient d'un essai gratuit de 30 jours de notre plan Pro avec un accès complet à toutes les fonctionnalités. Aucune carte de crédit n'est requise pour démarrer votre essai. À la fin de la période d'essai, vous devez sélectionner et payer un plan d'abonnement pour continuer à utiliser le Service."
        },
        "pricing": {
          "title": "Tarification et plans",
          "p1": "MortgageFlow.pro propose quatre niveaux d'abonnement : Lite, Growth, Pro et Enterprise. Chaque plan offre des fonctionnalités, des limitations et des tarifs différents. La tarification actuelle est disponible sur notre site Web et peut être mise à jour périodiquement avec un préavis de 30 jours aux abonnés existants.",
          "p2": "Les limitations des plans (comme le nombre maximum de dossiers et de prospects actifs) sont appliquées automatiquement. La mise à niveau vers un niveau supérieur débloquera immédiatement une capacité supplémentaire."
        },
        "billing": {
          "title": "Conditions de facturation",
          "item1": "Les abonnements sont facturés à l'avance sur une base mensuelle ou annuelle",
          "item2": "Les abonnements annuels bénéficient d'une tarification réduite (jusqu'à 50 % d'économies)",
          "item3": "Tous les frais sont non remboursables sauf si la loi l'exige ou pendant la période d'essai",
          "item4": "Nous pouvons modifier les prix avec un préavis de 30 jours aux abonnés existants",
          "item5": "Les paiements échoués peuvent entraîner la suspension du service jusqu'à réception du paiement"
        },
        "cancellation": {
          "title": "Annulation et remboursements",
          "p1": "Vous pouvez annuler votre abonnement à tout moment via les paramètres de votre compte. L'annulation prendra effet à la fin de votre période de facturation actuelle. Vous conserverez l'accès aux fonctionnalités payantes jusqu'à cette date. Aucun remboursement ne sera effectué pour les périodes de facturation partielles, sauf si la loi l'exige."
        }
      },
      "obligations": {
        "title": "Obligations de l'utilisateur et utilisation acceptable",
        "p1": "Vous acceptez d'utiliser notre Service uniquement à des fins légales et conformément à ces Conditions. Vous acceptez spécifiquement de NE PAS :",
        "item1": "Violer les lois, règlements ou droits de tiers applicables",
        "item2": "Utiliser le Service à des fins frauduleuses ou malveillantes",
        "item3": "Tenter d'obtenir un accès non autorisé à nos systèmes ou réseaux",
        "item4": "Interférer avec ou perturber le Service ou les serveurs",
        "item5": "Télécharger ou transmettre des virus, des logiciels malveillants ou du code malveillant",
        "item6": "Extraire, copier ou extraire des données du Service sans autorisation"
      },
      "intellectual": {
        "title": "Droits de propriété intellectuelle",
        "p1": "Le Service, y compris tous les logiciels, conceptions, textes, graphiques et autres contenus, est la propriété de MortgageFlow.pro et est protégé par le droit d'auteur, les marques de commerce et d'autres lois sur la propriété intellectuelle.",
        "p2": "Vous conservez la propriété de toutes les données client et du contenu que vous téléchargez sur le Service. En utilisant le Service, vous nous accordez une licence limitée pour stocker, traiter et afficher votre contenu uniquement pour vous fournir le Service."
      },
      "data": {
        "title": "Données et confidentialité",
        "p1": "Votre utilisation du Service est régie par notre Politique de confidentialité, qui est intégrée à ces Conditions par référence. Vous êtes responsable de vous assurer que vous avez l'autorisation appropriée pour collecter, utiliser et partager les informations client via notre plateforme.",
        "p2": "Vous déclarez et garantissez que votre utilisation du Service est conforme à toutes les lois et réglementations applicables en matière de confidentialité, y compris l'obtention des consentements nécessaires de vos clients."
      },
      "prohibited": {
        "title": "Activités interdites",
        "item1": "Revendre ou redistribuer le Service sans autorisation",
        "item2": "Faire de l'ingénierie inverse, décompiler ou tenter d'extraire le code source",
        "item3": "Utiliser le Service pour envoyer du spam ou des communications non sollicitées",
        "item4": "Usurper l'identité d'une autre personne ou entité",
        "item5": "Collecter des informations sur d'autres utilisateurs sans consentement",
        "item6": "Créer plusieurs comptes pour contourner les restrictions",
        "item7": "Violer les réglementations de l'industrie hypothécaire ou les normes professionnelles"
      },
      "availability": {
        "title": "Disponibilité et modifications du service",
        "p1": "Nous nous efforçons de fournir un service fiable et continu, mais nous ne garantissons pas un accès ininterrompu. Nous pouvons modifier, suspendre ou interrompre toute partie du Service à tout moment avec un préavis raisonnable. Nous ne serons pas responsables des modifications, suspensions ou interruptions.",
        "p2": "Les maintenances planifiées seront annoncées à l'avance dans la mesure du possible. Nous visons une disponibilité de 99,5 % mais ne fournissons pas de garanties SLA formelles, sauf pour les clients Enterprise avec des accords séparés."
      },
      "apiAccess": {
        "title": "Accès API et intégration",
        "p1": "L'accès API est disponible exclusivement pour les abonnés du plan Enterprise. L'utilisation de notre API est soumise à des limites de taux et à des politiques d'utilisation équitable.",
        "p2": "Vous ne pouvez pas utiliser l'API pour contourner les limites d'abonnement, extraire des données pour des services concurrents ou surcharger nos systèmes. Nous nous réservons le droit de révoquer l'accès API en cas d'abus ou de violation de ces Conditions."
      },
      "liability": {
        "title": "Limitation de responsabilité",
        "p1": "DANS LA MESURE MAXIMALE PERMISE PAR LA LOI, MORTGAGEFLOW.PRO NE SERA PAS RESPONSABLE DES DOMMAGES INDIRECTS, ACCESSOIRES, SPÉCIAUX, CONSÉCUTIFS OU PUNITIFS, OU DE TOUTE PERTE DE BÉNÉFICES OU DE REVENUS, QU'ILS SOIENT ENCOURUS DIRECTEMENT OU INDIRECTEMENT, OU DE TOUTE PERTE DE DONNÉES, D'UTILISATION OU D'AUTRES PERTES INTANGIBLES.",
        "p2": "Notre responsabilité totale envers vous pour toute réclamation découlant de ces Conditions ou de votre utilisation du Service ne dépassera pas le montant que vous nous avez payé au cours des 12 mois précédant la réclamation."
      },
      "warranty": {
        "title": "Exclusion de garantie",
        "p1": "LE SERVICE EST FOURNI « TEL QUEL » ET « TEL QUE DISPONIBLE » SANS GARANTIE D'AUCUNE SORTE, EXPRESSE OU IMPLICITE, Y COMPRIS, MAIS SANS S'Y LIMITER, LES GARANTIES IMPLICITES DE QUALITÉ MARCHANDE, D'ADÉQUATION À UN USAGE PARTICULIER ET DE NON-CONTREFAÇON.",
        "p2": "Nous ne garantissons pas que le Service sera ininterrompu, exempt d'erreurs ou sécurisé, ni que les défauts seront corrigés. Nous ne garantissons pas l'exactitude, l'exhaustivité ou la fiabilité de tout contenu ou donnée fourni par le Service.",
        "p3": "Vous reconnaissez que vous utilisez le Service à vos propres risques et que nous ne sommes pas responsables des décisions commerciales prises sur la base des informations ou des outils fournis par le Service."
      },
      "indemnification": {
        "title": "Indemnisation",
        "p1": "Vous acceptez d'indemniser, de défendre et de dégager de toute responsabilité MortgageFlow.pro, ses dirigeants, administrateurs, employés et agents de toute réclamation, responsabilité, dommage, perte et dépense découlant de votre utilisation du Service, de la violation de ces Conditions ou de la violation de tout droit de tiers."
      },
      "termination": {
        "title": "Résiliation",
        "p1": "Nous pouvons suspendre ou résilier votre compte et votre accès au Service à tout moment, avec ou sans motif, avec ou sans préavis, pour toute violation de ces Conditions ou pour toute autre raison.",
        "p2": "Lors de la résiliation, vous perdrez l'accès à votre compte et à vos données. Vous pouvez demander une exportation de vos données dans les 30 jours suivant la résiliation, après quoi nous pouvons supprimer définitivement vos données."
      },
      "dataRetention": {
        "title": "Conservation et exportation des données",
        "p1": "Nous conservons vos données pendant la durée de votre abonnement. Après l'annulation ou la résiliation, vos données resteront accessibles pendant 30 jours pour vous permettre de les exporter.",
        "p2": "Vous pouvez exporter vos données à tout moment via les paramètres de votre compte ou en contactant le support. Après la période de grâce de 30 jours, nous supprimerons définitivement et irréversiblement toutes vos données de nos systèmes conformément à nos politiques de conservation des données et aux lois applicables.",
        "p3": "Nous ne sommes pas responsables de toute perte de données résultant de votre défaut d'exporter les données avant la suppression définitive."
      },
      "governing": {
        "title": "Loi applicable et résolution des litiges",
        "p1": "Ces Conditions sont régies par les lois du Canada. Tout litige découlant de ces Conditions ou du Service sera résolu par arbitrage exécutoire conformément aux règles d'arbitrage applicables, sauf lorsque interdit par la loi."
      },
      "modifications": {
        "title": "Modifications des conditions",
        "p1": "Nous nous réservons le droit de modifier ces Conditions à tout moment. Nous vous informerons des changements importants par courriel ou via le Service. Votre utilisation continue du Service après une telle notification constitue l'acceptation des Conditions modifiées."
      },
      "contact": {
        "title": "Informations de contact",
        "p1": "Si vous avez des questions concernant ces conditions d'utilisation, veuillez nous contacter :",
        "email": "Courriel",
        "address": "Adresse",
        "addressValue": "Canada"
      }
    }
  },
  "mortgageCalculator": {
    "title": "Calculateur et comparateur d'hypothèques",
    "description": "Comparez plusieurs scénarios hypothécaires pour trouver la meilleure option pour vos besoins",
    "saveScenarios": "Enregistrer les scénarios",
    "viewHistory": "Voir l'historique",
    "hideHistory": "Masquer l'historique",
    "exportPDF": "Exporter PDF",
    "saving": "Enregistrement...",
    "saved": "Enregistré !",
    "saveFailed": "Échec de l'enregistrement",
    "generating": "Génération...",
    "customerName": "Nom du client",
    "customerNamePlaceholder": "Entrez le nom du client pour le PDF",
    "propertyAddress": "Adresse de la propriété",
    "propertyAddressPlaceholder": "Entrez l'adresse de la propriété pour le PDF",
    "activeScenarios": "Scénarios actifs",
    "scenario": "Scénario {{number}}",
    "bankLender": "Banque / Prêteur",
    "bankPlaceholder": "ex. Banque TD, RBC, Scotia, etc.",
    "commentsNotes": "Commentaires / Notes",
    "commentsPlaceholder": "Conditions spéciales, notes ou détails supplémentaires...",
    "coreFinancialCalculator": "Calculateur financier de base",
    "calculate": "Calculer",
    "calculatorInstructions": "Entrez 3 valeurs, laissez-en 1 vide, et cliquez sur Calculer pour trouver la valeur manquante.",
    "mortgageAmount": "Montant de l'hypothèque",
    "mortgageAmountPrincipal": "Montant de l'hypothèque (Capital)",
    "interestRate": "Taux d'intérêt (% par an)",
    "amortizationPeriod": "Période d'amortissement",
    "amortizationPeriodFull": "Période d'amortissement (Durée totale de remboursement)",
    "paymentAmount": "Montant du paiement",
    "months": "Mois",
    "monthsAbbr": "Mois",
    "years": "Années",
    "monthly": "Mensuel",
    "loadingCalculator": "Chargement du calculateur...",
    "best": "Meilleur",
    "highest": "Plus élevé",
    "savedScenariosHistory": "Historique des scénarios enregistrés",
    "browseSaved": "Parcourez et téléchargez les comparaisons hypothécaires précédemment enregistrées",
    "selectCustomer": "Sélectionner un client",
    "searchCustomers": "Rechercher des clients...",
    "loadingCustomers": "Chargement des clients...",
    "noCustomersFound": "Aucun client trouvé",
    "selectACustomer": "Sélectionner un client",
    "selectCustomerDesc": "Choisissez un client dans la liste pour voir ses scénarios hypothécaires enregistrés",
    "customerScenarios": "Scénarios de {{name}}",
    "savedScenarioCount": "{{count}} scénario enregistré",
    "savedScenarioCount_plural": "{{count}} scénarios enregistrés",
    "noSavedScenarios": "Aucun scénario enregistré",
    "noSavedScenariosDesc": "Ce client n'a pas encore de scénarios hypothécaires enregistrés",
    "deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce scénario enregistré ?",
    "download": "Télécharger",
    "generating": "Génération...",
    "customer": "Client",
    "property": "Propriété",
    "deleteScenario": "Supprimer le scénario",
    "scenarioComparison": "Comparaison des scénarios",
    "propertyValue": "Valeur de la propriété",
    "scenario1": "Scénario 1",
    "scenario2": "Scénario 2",
    "scenario3": "Scénario 3"
  },
  "sms": {
    "conversations": "Conversations",
    "noPhone": "Pas de téléphone",
    "applicant": "Demandeur",
    "coApplicant": "Co-demandeur",
    "readOnlyMode": "Mode lecture seule",
    "noMessages": "Aucun message pour le moment. Commencez une conversation !",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "typeMessage": "Tapez un message...",
    "sendingFrom": "Envoi depuis",
    "customerNoPhone": "Le client n'a pas de numéro de téléphone",
    "noPhoneNumberAssigned": "Vous avez besoin d'un numéro de téléphone assigné pour envoyer des SMS. Contactez votre administrateur.",
    "errorFetchingMessages": "Erreur lors de la récupération des messages",
    "noPhoneNumber": "Le client n'a pas de numéro de téléphone",
    "errorSendingMessage": "Erreur lors de l'envoi du message",
    "noCustomers": "Aucun client",
    "noCustomersDescription": "Ce dossier n'a aucun client associé. Ajoutez des clients pour commencer des conversations SMS."
  },
  "conversations": {
    "title": "Messages",
    "newChat": "Nouveau chat",
    "searchPlaceholder": "Rechercher des conversations...",
    "noConversationsFound": "Aucune conversation trouvée",
    "noConversationsYet": "Aucune conversation SMS pour le moment",
    "relatedPerson": "Personne liée",
    "unknown": "Inconnu",
    "selectConversation": "Sélectionnez une conversation",
    "selectConversationDescription": "Choisissez une conversation dans la barre latérale pour commencer à envoyer des messages",
    "startNewConversation": "Démarrer une nouvelle conversation",
    "searchContactsPlaceholder": "Rechercher des clients et contacts...",
    "orEnterPhoneNumber": "Ou entrez un numéro de téléphone",
    "phoneNumberPlaceholder": "ex: +1 514 123 4567",
    "startConversation": "Démarrer la conversation",
    "invalidPhoneNumber": "Veuillez entrer un numéro de téléphone valide",
    "searching": "Recherche en cours...",
    "noContactsFound": "Aucun contact trouvé",
    "typeToSearch": "Tapez pour rechercher des clients et contacts",
    "contact": "Contact",
    "deleteConversation": "Supprimer la conversation",
    "deleteConversationConfirm": "Êtes-vous sûr de vouloir supprimer cette conversation avec",
    "deleteConversationWarning": "Cette action ne peut pas être annulée. Tous les messages de cette conversation seront définitivement supprimés.",
    "loadingConversations": "Chargement des conversations...",
    "realTime": "Temps réel",
    "reconnecting": "Reconnexion...",
    "typeMessage": "Tapez un message...",
    "phoneNumberRequired": "Numéro de téléphone requis",
    "phoneNumberRequiredDescription": "Pour utiliser les conversations SMS, vous devez configurer un numéro de téléphone dédié. Cela vous permet d'envoyer et de recevoir des messages avec vos clients.",
    "setupPhoneNumber": "Configurer le numéro de téléphone",
    "phoneNumberHint": "Une fois configuré, vous pourrez envoyer et recevoir des messages SMS depuis cette page."
  },
  "calls": {
    "comingSoon": "Bientôt disponible",
    "comingSoonDescription": "La fonctionnalité d'enregistrement d'appels est actuellement en développement et sera bientôt disponible. Restez à l'écoute!",
    "comingSoonHint": "Cette fonctionnalité vous permettra de visualiser, gérer et analyser vos enregistrements d'appels avec transcription et analyse IA."
  },
  "reports": {
    "title": "Rapports",
    "subtitle": "Générez des rapports et des analyses complètes pour votre entreprise",
    "selectCategory": "Sélectionner une catégorie de rapport",
    "availableReports": "Rapports disponibles",
    "noReports": "Aucun rapport disponible dans cette catégorie",
    "dateRange": "Plage de dates",
    "filterable": "Filtrable",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "refresh": "Actualiser",
    "filters": "Filtres",
    "applyFilters": "Appliquer les filtres",
    "exportCSV": "Exporter CSV",
    "exportPDF": "Exporter PDF",
    "noData": "Aucune donnée disponible pour les critères sélectionnés",
    "categories": {
      "all": "Tous les rapports",
      "allDescription": "Voir tous les rapports disponibles",
      "sales": "Ventes et revenus",
      "salesDescription": "Performance financière et rapports de commission",
      "customers": "Clients et prospects",
      "customersDescription": "Acquisition et conversion de clients",
      "deals": "Dossiers et pipeline",
      "dealsDescription": "Suivi des dossiers et analyse du pipeline",
      "activities": "Tâches et activités",
      "activitiesDescription": "Achèvement des tâches et suivi des activités",
      "communications": "Communications",
      "communicationsDescription": "Journaux d'appels et analyses de messages",
      "performance": "Performance",
      "performanceDescription": "Performance de l'équipe et tendances"
    },
    "revenueSummary": {
      "name": "Résumé des revenus",
      "description": "Répartition totale des revenus par période"
    },
    "commissionReport": {
      "name": "Rapport de commission",
      "description": "Gains de commission détaillés par dossier"
    },
    "dealPipelineValue": {
      "name": "Valeur du pipeline",
      "description": "Valeur actuelle des dossiers dans le pipeline"
    },
    "customerList": {
      "name": "Liste des clients",
      "description": "Liste complète de tous les clients"
    },
    "customerAcquisition": {
      "name": "Acquisition de clients",
      "description": "Croissance des nouveaux clients au fil du temps"
    },
    "leadConversion": {
      "name": "Conversion de prospects",
      "description": "Taux de conversion de prospects en clients"
    },
    "dealsByStatus": {
      "name": "Dossiers par statut",
      "description": "Répartition des dossiers par statut"
    },
    "dealsByType": {
      "name": "Dossiers par type",
      "description": "Répartition des dossiers par type"
    },
    "closedDeals": {
      "name": "Dossiers fermés",
      "description": "Tous les dossiers fermés dans la période"
    },
    "dealDuration": {
      "name": "Durée des dossiers",
      "description": "Temps moyen pour fermer les dossiers"
    },
    "tasksSummary": {
      "name": "Résumé des tâches",
      "description": "Aperçu de toutes les tâches"
    },
    "tasksCompletion": {
      "name": "Taux d'achèvement des tâches",
      "description": "Statistiques d'achèvement des tâches"
    },
    "appointments": {
      "name": "Rendez-vous",
      "description": "Rendez-vous et réunions du calendrier"
    },
    "callLog": {
      "name": "Journal d'appels",
      "description": "Historique complet des appels"
    },
    "messageVolume": {
      "name": "Volume de messages",
      "description": "Statistiques SMS et messages"
    },
    "communicationSummary": {
      "name": "Résumé des communications",
      "description": "Activité de communication globale"
    },
    "brokerPerformance": {
      "name": "Performance du courtier",
      "description": "Statistiques individuelles des courtiers"
    },
    "conversionRates": {
      "name": "Taux de conversion",
      "description": "Métriques de conversion de prospects et dossiers"
    },
    "monthlyTrends": {
      "name": "Tendances mensuelles",
      "description": "Tendances de performance mois par mois"
    },
    "filterLabels": {
      "status": "Statut",
      "source": "Source",
      "assigned_to": "Assigné à"
    },
    "filterPlaceholders": {
      "status": "Filtrer par statut",
      "source": "Filtrer par source",
      "assigned_to": "Filtrer par assigné"
    }
  },
  "landing": {
    "nav": {
      "signIn": "Se connecter",
      "getStarted": "Commencer"
    },
    "hero": {
      "title": "CRM hypothécaire conçu pour",
      "titleHighlight": "courtiers modernes",
      "subtitle": "Gestion complète des clients, suivi des dossiers et outils d'automatisation IA spécifiquement conçus pour votre équipe.",
      "startTrial": "Démarrer l'essai gratuit",
      "viewDemo": "Voir la démo",
      "description": "Améliorez vos communications internes sur une plateforme sécurisée de confiance."
    },
    "highlights": {
      "setupTime": {
        "label": "Temps d'installation",
        "value": "5 minutes",
        "description": "Processus d'intégration rapide"
      },
      "freeTrial": {
        "label": "Essai gratuit",
        "value": "30 jours",
        "description": "Aucune carte de crédit requise"
      },
      "support": {
        "label": "Support",
        "value": "24/7",
        "description": "Toujours là pour vous aider"
      }
    },
    "features": {
      "title": "Tout ce dont vous avez besoin sur une seule plateforme",
      "subtitle": "Rationalisez votre flux de travail avec des outils conçus spécifiquement pour les professionnels hypothécaires.",
      "clientManagement": {
        "title": "Gestion des clients",
        "description": "Profils complets, historique des contacts, stockage de documents et suivis automatisés, le tout au même endroit.",
        "features": {
          "profiles": "Profils clients détaillés",
          "followups": "Suivis automatisés",
          "documents": "Gestion des documents"
        }
      },
      "dealPipeline": {
        "title": "Pipeline de dossiers",
        "description": "Suivi visuel des dossiers avec étapes personnalisables, suivi des commissions et mises à jour en temps réel.",
        "features": {
          "kanban": "Tableaux de style Kanban",
          "commission": "Calculateur de commissions",
          "progress": "Suivi de la progression"
        }
      },
      "aiAutomation": {
        "title": "Automatisation IA",
        "description": "Résumés automatiques des conversations, gestion intelligente des tâches et assistance de planification intelligente.",
        "features": {
          "summaries": "Résumés IA",
          "scheduling": "Planification intelligente",
          "tasks": "Automatisation des tâches"
        }
      },
      "calendar": {
        "title": "Calendrier et rendez-vous",
        "description": "Planifiez des réunions et gérez vos rendez-vous"
      },
      "teamCollaboration": {
        "title": "Collaboration d'équipe",
        "description": "Invitez des membres et travaillez ensemble"
      },
      "leadManagement": {
        "title": "Gestion des prospects",
        "description": "Capturez, suivez et convertissez vos prospects"
      },
      "emailIntegration": {
        "title": "Intégration courriel",
        "description": "Envoyez et suivez vos courriels directement depuis le CRM"
      },
      "workflows": {
        "title": "Flux de travail et automatisation",
        "description": "Automatisez les tâches et processus répétitifs"
      },
      "customForms": {
        "title": "Formulaires personnalisés",
        "description": "Créez des formulaires d'admission et de demande personnalisés"
      },
      "reports": {
        "title": "Rapports et analytique",
        "description": "Générez des rapports d'affaires complets"
      },
      "analytics": {
        "title": "Analytique",
        "description": "Métriques de performance et informations"
      },
      "customDashboard": {
        "title": "Tableau de bord personnalisé",
        "description": "Personnalisez votre espace de travail avec des widgets"
      },
      "communications": {
        "title": "Communications",
        "description": "Appels, SMS et messagerie intégrés"
      },
      "security": {
        "title": "Sécurité",
        "description": "Protection des données de niveau entreprise"
      },
      "mobile": {
        "title": "Mobile",
        "description": "Accès depuis n'importe quel appareil, n'importe où"
      }
    },
    "pricing": {
      "title": "Tarification simple et transparente",
      "subtitle": "Commencez avec un essai gratuit de 30 jours de notre version Pro — aucune carte de crédit requise",
      "monthly": "Mensuel",
      "annually": "Annuel",
      "annuallySave": "Économisez jusqu'à 50%",
      "perMonth": "/mois",
      "billed": "facturé",
      "freeTrial": "Essai Pro de 30 jours inclus",
      "lite": {
        "name": "Lite",
        "monthlyPrice": "19",
        "annualPrice": "9",
        "description": "Parfait pour les courtiers individuels qui débutent",
        "features": [
          "Jusqu'à 10 dossiers actifs",
          "Jusqu'à 20 prospects actifs",
          "Fonctionnalités CRM de base",
          "Intégration courriel et SMS",
          "Accès mobile",
          "Sécurité de niveau entreprise",
          "Support par courriel"
        ],
        "cta": "Démarrer l'essai gratuit"
      },
      "growth": {
        "name": "Growth",
        "monthlyPrice": "39",
        "annualPrice": "29",
        "description": "Pour les équipes et cabinets en croissance",
        "features": [
          "Tout dans Lite",
          "Dossiers et prospects illimités",
          "CRM avancé et automatisation",
          "Collaboration d'équipe",
          "Flux de travail personnalisés",
          "Sécurité de niveau entreprise",
          "Support prioritaire"
        ],
        "cta": "Démarrer l'essai gratuit",
        "popular": "Le plus populaire"
      },
      "pro": {
        "name": "Pro",
        "monthlyPrice": "69",
        "annualPrice": "49",
        "description": "Fonctionnalités avancées pour les cabinets établis",
        "features": [
          "Tout dans Growth",
          "Calendrier et rendez-vous",
          "Intégration Calendly",
          "Formulaires personnalisés",
          "Gestion des flux de travail IA",
          "Analytique et rapports avancés",
          "Options marque blanche",
          "Sécurité de niveau entreprise",
          "Gestionnaire de compte dédié"
        ],
        "cta": "Démarrer l'essai gratuit"
      },
      "enterprise": {
        "name": "Enterprise",
        "price": "Sur mesure",
        "description": "Solutions personnalisées pour les grandes organisations",
        "features": [
          "Tout dans Pro",
          "Développement personnalisé",
          "Garanties SLA",
          "Sécurité de niveau entreprise",
          "Intégration personnalisée",
          "Accès API",
          "Support téléphonique prioritaire 24/7"
        ],
        "cta": "Contactez-nous"
      }
    },
    "cta": {
      "title": "Commencez à gérer vos dossiers plus efficacement",
      "subtitle": "Rejoignez les professionnels hypothécaires qui utilisent MortgageFlow pour rationaliser leur flux de travail. Essayez gratuitement pendant 30 jours.",
      "getStarted": "Commencer gratuitement",
      "signIn": "Se connecter",
      "footer": "Aucune carte de crédit requise • Essai gratuit de 30 jours • Annuler à tout moment"
    },
    "footer": {
      "privacy": "Confidentialité",
      "terms": "Conditions",
      "support": "Support",
      "contact": "Contact",
      "copyright": "© 2026 MortgageFlow. Tous droits réservés."
    },
    "mockup": {
      "widget1": "Dossiers actifs",
      "widget2": "Activité récente",
      "widget3": "Suivi des commissions",
      "widget4": "Aperçu des tâches"
    }
  },
  "reports": {
    "title": "Rapports",
    "subtitle": "Générer et télécharger des rapports d'affaires complets",
    "selectCategory": "Sélectionner la Catégorie de Rapport",
    "availableReports": "Rapports Disponibles",
    "noReports": "Aucun rapport disponible dans cette catégorie",
    "noData": "Aucune donnée disponible pour ce rapport",
    "dateRange": "Plage de Dates",
    "filterable": "Filtrable",
    "startDate": "Date de Début",
    "endDate": "Date de Fin",
    "refresh": "Actualiser le Rapport",
    "filters": "Filtres",
    "applyFilters": "Appliquer les Filtres",
    "exportCSV": "Exporter CSV",
    "exportPDF": "Exporter PDF",
    "categories": {
      "all": "Tous les Rapports",
      "allDescription": "Voir tous les rapports disponibles",
      "sales": "Rapports de Ventes",
      "salesDescription": "Revenus, commissions et valeur du pipeline",
      "customers": "Rapports Clients",
      "customersDescription": "Listes de clients, acquisition et conversion",
      "deals": "Rapports d'Affaires",
      "dealsDescription": "Statut, types et performance des affaires",
      "activities": "Rapports d'Activité",
      "activitiesDescription": "Tâches, rendez-vous et suivi d'achèvement",
      "communications": "Rapports de Communication",
      "communicationsDescription": "Journaux d'appels, messages et résumé des communications",
      "performance": "Rapports de Performance",
      "performanceDescription": "Performance du courtier, taux de conversion et tendances"
    },
    "revenueSummary": {
      "name": "Résumé des Revenus",
      "description": "Aperçu des revenus et commissions des affaires conclues"
    },
    "commissionReport": {
      "name": "Rapport de Commissions",
      "description": "Détail des commissions gagnées"
    },
    "dealPipelineValue": {
      "name": "Valeur du Pipeline d'Affaires",
      "description": "Valeur actuelle de toutes les affaires actives dans le pipeline"
    },
    "customerList": {
      "name": "Liste des Clients",
      "description": "Liste complète des clients avec filtres"
    },
    "customerAcquisition": {
      "name": "Acquisition de Clients",
      "description": "Nouveaux clients acquis par date et source"
    },
    "leadConversion": {
      "name": "Conversion de Prospects",
      "description": "Métriques de conversion de prospects en clients"
    },
    "dealsByStatus": {
      "name": "Affaires par Statut",
      "description": "Répartition des affaires par statut actuel"
    },
    "dealsByType": {
      "name": "Affaires par Type",
      "description": "Analyse des affaires par type d'hypothèque"
    },
    "closedDeals": {
      "name": "Affaires Conclues",
      "description": "Toutes les affaires conclues avec succès"
    },
    "dealDuration": {
      "name": "Durée des Affaires",
      "description": "Temps écoulé de la création à la conclusion de l'affaire"
    },
    "tasksSummary": {
      "name": "Résumé des Tâches",
      "description": "Aperçu des tâches par statut"
    },
    "tasksCompletion": {
      "name": "Achèvement des Tâches",
      "description": "Tâches complétées avec analyse du temps"
    },
    "appointments": {
      "name": "Rendez-vous",
      "description": "Liste de tous les rendez-vous"
    },
    "callLog": {
      "name": "Journal d'Appels",
      "description": "Journal complet de tous les appels téléphoniques"
    },
    "messageVolume": {
      "name": "Volume de Messages",
      "description": "Volume de messages SMS par date et direction"
    },
    "communicationSummary": {
      "name": "Résumé des Communications",
      "description": "Résumé combiné des appels et messages"
    },
    "brokerPerformance": {
      "name": "Performance du Courtier",
      "description": "Métriques globales de performance du courtier"
    },
    "conversionRates": {
      "name": "Taux de Conversion",
      "description": "Analyse du taux de conversion et de succès des affaires"
    },
    "monthlyTrends": {
      "name": "Tendances Mensuelles",
      "description": "Tendances et patterns de performance mensuels"
    },
    "filterLabels": {
      "status": "Statut",
      "source": "Source",
      "assigned_to": "Assigné à"
    },
    "filterPlaceholders": {
      "status": "Filtrer par statut...",
      "source": "Filtrer par source...",
      "assigned_to": "Filtrer par utilisateur..."
    },
    "selectReportPrompt": "Sélectionner un Rapport",
    "selectReportDescription": "Choisissez un rapport parmi les catégories ci-dessus pour afficher les données",
    "generateReport": "Générer le Rapport",
    "generating": "Génération du Rapport..."
  },
  "impersonating": "Vous impersonnifiez un utilisateur. Soyez prudent avec les changements.",
  "switchBack": "Revenir à mon compte",
  "dealValidation": {
    "title": "Compléter les champs requis",
    "subtitle": "Remplissez les informations manquantes pour déplacer ce dossier vers",
    "required": "requis",
    "saveAndMove": "Enregistrer et déplacer",
    "saving": "Enregistrement…",
    "cancel": "Annuler",
    "noMissingFields": "Aucun champ manquant détecté.",
    "stillMissing": "Encore manquant",
    "errorOccurred": "Une erreur inattendue s'est produite",
    "fields": {
      "amount": "Montant du dossier",
      "customer_id": "Client",
      "lender_id": "Prêteur",
      "lender_name": "Nom du prêteur",
      "deal_type_id": "Type de dossier",
      "closing_date": "Date de clôture",
      "description": "Notes",
      "notes": "Notes",
      "base_points": "Points de base",
      "bonus_points": "Points bonus",
      "volume_points": "Points de volume",
      "property_address": "Adresse de la propriété",
      "funded_date": "Date de financement",
      "commission_amount": "Montant de commission"
    },
    "lender": {
      "searchPlaceholder": "Rechercher un prêteur…",
      "createNew": "Créer \"{{name}}\"",
      "selectPlaceholder": "Sélectionner un prêteur…",
      "creating": "Création…",
      "noResults": "Aucun prêteur trouvé"
    },
    "select": {
      "client": "Sélectionner un client…",
      "dealType": "Sélectionner un type de dossier…"
    }
  }
} 